(()=>{
function rfAsset(p){return window.ranchFlyerAssets[p]||p}
function rfImage(){const image=new Image();image.crossOrigin='anonymous';return image}
const defaults = {
  paperColor: "yellow",
  titleScale: "100",
  lineOneScale: "100",
  lineTwoScale: "100",
  lineThreeScale: "100",
  topline: "EPIC RECORDING ARTISTS",
  headlineOne: "PEARL",
  headlineTwo: "JAM",
  headlineThree: "",
  guestLabel: "SPECIAL GUESTS",
  supportAct: "TRIBE AFTER TRIBE",
  dateLine: "SUNDAY MAY 3, 1992",
  agesLine: "ALL AGES WELCOME",
  doorsLine: "DOORS OPEN 6:00 PM",
  showLine: "SHOW STARTS 8:00 PM",
  venueLine: "Ranch Bowl Entertainment Center",
  addressLine: "1600 South 72nd Street  -  Omaha, NE",
  noteLine: "ADVANCE TICKETS $10.75  DAY OF SHOW $12.75",
  tinyLineOne: "TICKETS AVAILABLE AT ALL AREA TICKETMASTER OUTLETS INCLUDING",
  tinyLineTwo: "HASTINGS, KARMAN MUSIC, OMAHA TICKET OFFICE, CHARGE/IT, HOMERUN MUSIC AND",
  tinyLineThree: "THE RANCH BOWL BOX OFFICE (402) 397-3950"
};

function ranchShow({
  paperColor = "yellow",
  titleScale = "100",
  lineOneScale = "100",
  lineTwoScale = "100",
  lineThreeScale = "100",
  topline = "SPECIAL ENGAGEMENT",
  headlineOne,
  headlineTwo = "",
  headlineThree = "",
  guestLabel = "SPECIAL GUESTS",
  supportAct = "RANCH BOWL SHOW",
  dateLine,
  agesLine = "ALL AGES WELCOME",
  doorsLine = "DOORS OPEN 6:00 PM",
  showLine = "SHOW STARTS 8:00 PM",
  venueLine = "Ranch Bowl Entertainment Center",
  addressLine = "1600 South 72nd Street  -  Omaha, NE",
  noteLine = "ADVANCE TICKETS AVAILABLE AT TICKETMASTER OUTLETS",
  tinyLineOne = "TICKETS AVAILABLE AT THE RANCH BOWL BOX OFFICE, HOMER'S AND PICKLES",
  tinyLineTwo = "ALL AREA TICKETMASTER LOCATIONS AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
  tinyLineThree = "RANCH BOWL BOX OFFICE (402) 397-3950  OMAHA, NEBRASKA"
}) {
  return {
    paperColor,
    titleScale,
    lineOneScale,
    lineTwoScale,
    lineThreeScale,
    topline,
    headlineOne,
    headlineTwo,
    headlineThree,
    guestLabel,
    supportAct,
    dateLine,
    agesLine,
    doorsLine,
    showLine,
    venueLine,
    addressLine,
    noteLine,
    tinyLineOne,
    tinyLineTwo,
    tinyLineThree
  };
}

const ranchBowlShows = [
  ranchShow({
    topline: "EPIC RECORDING ARTISTS",
    headlineOne: "PEARL",
    headlineTwo: "JAM",
    supportAct: "TRIBE AFTER TRIBE",
    dateLine: "SUNDAY MAY 3, 1992",
    doorsLine: "DOORS OPEN 6:00 PM",
    showLine: "SHOW STARTS 8:00 PM",
    noteLine: "ADVANCE TICKETS $10.75  DAY OF SHOW $12.75",
    tinyLineOne: "TICKETS AVAILABLE AT ALL AREA TICKETMASTER OUTLETS INCLUDING",
    tinyLineTwo: "HASTINGS, KARMAN MUSIC, OMAHA TICKET OFFICE, CHARGE/IT, HOMERUN MUSIC AND",
    tinyLineThree: "THE RANCH BOWL BOX OFFICE (402) 397-3950"
  }),
  ranchShow({
    paperColor: "green",
    topline: "FIRST NEBRASKA SHOW",
    headlineOne: "GREEN",
    headlineTwo: "DAY",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "PANSY DIVISION",
    dateLine: "THURSDAY JULY 14, 1994",
  }),
  ranchShow({
    paperColor: "orange",
    topline: "MOTHER'S MILK TOUR",
    headlineOne: "RED HOT",
    headlineTwo: "CHILI PEPPERS",
    guestLabel: "ONE NIGHT ONLY",
    supportAct: "RANCH BOWL SHOW",
    dateLine: "WEDNESDAY OCTOBER 11, 1989",
  }),
  ranchShow({
    topline: "OMAHA RECORDING ARTISTS",
    headlineOne: "311",
    headlineTwo: "",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "YARD APES",
    dateLine: "SATURDAY JANUARY 25, 1992",
  }),
  ranchShow({
    topline: "SPECIAL ENGAGEMENT",
    headlineOne: "THE",
    headlineTwo: "AQUABATS",
    supportAct: "THE PHENOMENAUTS",
    dateLine: "SATURDAY JULY 9, 2005",
  }),
  ranchShow({
    paperColor: "red",
    topline: "VULGAR DISPLAY TOUR",
    headlineOne: "PANTERA",
    headlineTwo: "",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "WHITE ZOMBIE",
    dateLine: "THURSDAY DECEMBER 10, 1992",
  }),
  ranchShow({
    paperColor: "blue",
    topline: "AMICA'S AND ROCK PRESENTS",
    headlineOne: "WARRANT",
    headlineTwo: "",
    guestLabel: "SPECIAL GUESTS: TBA",
    supportAct: "RANCH BOWL SHOW",
    dateLine: "TUESDAY SEPTEMBER 14, 1999",
    agesLine: "21 & OVER ONLY",
    noteLine: "$15.00 ADVANCE  $16.00 DAY OF SHOW",
  }),
  ranchShow({
    paperColor: "orange",
    topline: "SUBHUMAN RACE TOUR",
    headlineOne: "SKID",
    headlineTwo: "ROW",
    guestLabel: "ONE NIGHT ONLY",
    supportAct: "RANCH BOWL SHOW",
    dateLine: "WEDNESDAY MAY 17, 1995",
  }),
  ranchShow({
    topline: "AFTERTASTE TOUR",
    headlineOne: "HELMET",
    headlineTwo: "",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "MELVINS",
    dateLine: "SUNDAY JULY 6, 1997",
  }),
  ranchShow({
    paperColor: "pink",
    topline: "THE BEAUTY PROCESS",
    headlineOne: "L7",
    headlineTwo: "",
    guestLabel: "ONE NIGHT ONLY",
    supportAct: "RANCH BOWL SHOW",
    dateLine: "WEDNESDAY SEPTEMBER 3, 1997",
  }),
  ranchShow({
    topline: "CAN'T STOP THE ROCK",
    headlineOne: "STRYPER",
    headlineTwo: "",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "BRIDE",
    dateLine: "THURSDAY DECEMBER 5, 1991",
  }),
  ranchShow({
    topline: "SPECIAL ENGAGEMENT",
    headlineOne: "KING'S",
    headlineTwo: "X",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "THE LOST",
    dateLine: "SUNDAY MAY 31, 1992",
  }),
  ranchShow({
    topline: "SPECIAL ENGAGEMENT",
    headlineOne: "ANI",
    headlineTwo: "DIFRANCO",
    guestLabel: "ONE NIGHT ONLY",
    supportAct: "RANCH BOWL SHOW",
    dateLine: "FRIDAY JULY 2, 1999",
  }),
  ranchShow({
    topline: "SPECIAL ENGAGEMENT",
    headlineOne: "REVEREND",
    headlineTwo: "HORTON HEAT",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "LET'S GO BOWLING",
    dateLine: "SUNDAY FEBRUARY 1, 1998",
  }),
  ranchShow({
    topline: "SPECIAL ENGAGEMENT",
    headlineOne: "FINCH",
    headlineTwo: "",
    supportAct: "VENDETTA RED",
    dateLine: "THURSDAY MAY 26, 2005",
  }),
  ranchShow({
    topline: "SPECIAL ENGAGEMENT",
    headlineOne: "MINDLESS",
    headlineTwo: "SELF INDULGENCE",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "HASTE THE DAY",
    dateLine: "FRIDAY MAY 20, 2005",
  }),
  ranchShow({
    topline: "SPECIAL ENGAGEMENT",
    headlineOne: "AGNOSTIC",
    headlineTwo: "FRONT",
    supportAct: "FULL BLOWN CHAOS",
    dateLine: "SUNDAY MAY 15, 2005",
  }),
  ranchShow({
    topline: "SPECIAL ENGAGEMENT",
    headlineOne: "DREDG",
    headlineTwo: "",
    supportAct: "CIRCA SURVIVE",
    dateLine: "THURSDAY MAY 5, 2005",
  }),
  ranchShow({
    topline: "SPECIAL ENGAGEMENT",
    headlineOne: "HANK",
    headlineTwo: "WILLIAMS III",
    guestLabel: "ONE NIGHT ONLY",
    supportAct: "RANCH BOWL SHOW",
    dateLine: "MONDAY APRIL 25, 2005",
  }),
  // Transcription: BUFFALO TOM
  //   EAST/WEST RECORDS RECORDING ARTIST
  //   BUFFALO TOM
  //   [band photo]
  //   SPECIAL GUEST: SAINT JOHNNY
  //   MONDAY, FEBRUARY 21, 1994
  //   ALL AGES WELCOME
  //   ADV. TIX $8.75 / DOS $10.75
  //   DOORS OPEN 8:00 / SHOW STARTS 9:00
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING YOUNKERS, HOMERS, PICKLES AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  ranchShow({
    topline: "EAST/WEST RECORDS RECORDING ARTIST",
    headlineOne: "BUFFALO",
    headlineTwo: "TOM",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "SAINT JOHNNY",
    dateLine: "MONDAY, FEBRUARY 21, 1994",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00",
    showLine: "SHOW STARTS 9:00",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADV. TIX $8.75 / DOS $10.75",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING YOUNKERS, HOMERS, PICKLES AND",
    tinyLineThree: "THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: BOB MOULD
  //   CAPITOL RECORDS RECORDING ARTIST
  //   BOB MOULD
  //   SPECIAL GUEST: TO BE ANNOUNCED
  //   SUNDAY OCTOBER 3, 1993
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $12.00 DAY OF SHOW $13.00
  //   DOORS OPEN 8:00 PM SHOW STARTS 9:00 PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  ranchShow({
    topline: "CAPITOL RECORDS RECORDING ARTIST",
    headlineOne: "BOB",
    headlineTwo: "MOULD",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "TO BE ANNOUNCED",
    dateLine: "SUNDAY OCTOBER 3, 1993",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADVANCE TICKETS $12.00 DAY OF SHOW $13.00",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING YOUNKERS, PICKLES, HOMERS, AND",
    tinyLineThree: "THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: TOAD THE WET SPROCKET
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   1606 south 72nd street • omaha, nebraska 68124 • 402-393-0900 • fax: 402-393-8455
  //   93K ROCK
  //   PRESENTS COLUMBIA RECORDING ARTISTS
  //   TOAD THE WET SPROCKET
  //   SPECIAL GUESTS MARVIN ETZIONI (FORMERLY OF LONE JUSTICE)
  //   MONDAY, FEBRUARY 24, 1992
  //   ALL AGES WELCOME
  //   DOORS OPEN 7:30 PM
  //   SHOW STARTS 8:30 PM
  //   ADVANCE TICKETS $5.50 DAY OF SHOW $6.50
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET CENTERS INCLUDING YOUNKERS, PICKLES, HOMERS AND THE OMAHA CIVIC AUDITORIUM.
  //   [unreadable: a line of dots or text along the bottom edge]
  //   [generic Ranch Bowl info filled in: 1 ticket line]
  ranchShow({
    lineOneScale: "110",
    lineTwoScale: "110",
    topline: "93K ROCK PRESENTS COLUMBIA RECORDING ARTISTS",
    headlineOne: "TOAD THE",
    headlineTwo: "WET SPROCKET",
    headlineThree: "",
    guestLabel: "SPECIAL GUESTS",
    supportAct: "MARVIN ETZIONI (FORMERLY OF LONE JUSTICE)",
    dateLine: "MONDAY, FEBRUARY 24, 1992",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 7:30 PM",
    showLine: "SHOW STARTS 8:30 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1606 south 72nd street • omaha, nebraska 68124 • 402-393-0900 • fax: 402-393-8455",
    noteLine: "ADVANCE TICKETS $5.50 DAY OF SHOW $6.50",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET CENTERS",
    tinyLineTwo: "INCLUDING YOUNKERS, PICKLES, HOMERS AND THE OMAHA CIVIC AUDITORIUM.",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: NILS LOFGREN
  //   PURE RECORDS RECORDING ARTIST
  //   NILS LOFGREN
  //   [handwritten autograph: "2 Dan [uncertain] / Believe! [uncertain] / Nils Lofgren [uncertain: signature] / '96 [uncertain]"]
  //   SUNDAY MARCH 3, 1996
  //   DOORS 8:00 PM / SHOW 9:00 PM
  //   OVER 21 ONLY
  //   TICKETS $10.75 ADVANCE $11.75 DAY OF SHOW
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS INCLUDING: YOUNKERS, PICKLES, HOMERS AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   933K·ROCK [uncertain: 93.3 K-ROCK]
  //   [pink backstage pass hanging beside the poster, cut off at left: "...KSTAGE ONLY / ...ILS LOFGREN / ...he Towson Center / Saturday / August 6, 1994"]
  //   [generic Ranch Bowl info filled in: guest lines]
  ranchShow({
    topline: "PURE RECORDS RECORDING ARTIST",
    headlineOne: "NILS",
    headlineTwo: "LOFGREN",
    headlineThree: "",
    guestLabel: "ONE NIGHT ONLY",
    supportAct: "RANCH BOWL SHOW",
    dateLine: "SUNDAY MARCH 3, 1996",
    agesLine: "OVER 21 ONLY",
    doorsLine: "DOORS 8:00 PM",
    showLine: "SHOW 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93.3 K-ROCK",
    noteLine: "TICKETS $10.75 ADVANCE $11.75 DAY OF SHOW",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS INCLUDING: YOUNKERS, PICKLES, HOMERS AND",
    tinyLineThree: "THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: THE URGE - JULY 1998 (carousel, slide 1)
  //   NICK & ERIC'S [logo; small text around it unreadable]
  //   PRESENTS THE URGE
  //   SPECIAL G[covered by ticket]
  //   2 SKINNEE J's
  //   KOTTONMOUTH KINGS
  //   SPRUNG MONKEY
  //   WEDNESDAY JULY 8, 1998 AND THURSDAY JULY 9, 1998
  //   [ticket laid on top: "RANCH BOWL PRESENTS THE URGE W/ SPRUNG MONKEY-2 SKINEE JS KOTTONMOUTH KINGS 1600 S. 72ND STREET THU JUL 9 1998 7:30 PM · GENADM GA2 63 A 14.00 · ADMIT ONE PERSON"]
  //   [generic Ranch Bowl info filled in: ages, doors, show, name split onto two lines, venue, address, ticket note, 3 ticket line(s)]
  ranchShow({
    topline: "NICK & ERIC'S PRESENTS",
    headlineOne: "THE",
    headlineTwo: "URGE",
    headlineThree: "",
    guestLabel: "SPECIAL GUESTS",
    supportAct: "2 SKINNEE J's / KOTTONMOUTH KINGS / SPRUNG MONKEY",
    dateLine: "WEDNESDAY JULY 8, 1998 AND THURSDAY JULY 9, 1998",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "ADVANCE TICKETS AVAILABLE AT TICKETMASTER OUTLETS",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: THE URGE - DECEMBER 1998 (same carousel, slide 2)
  //   NICK & ERIC'S [logo] PRESENTS
  //   THE URGE
  //   2 BIG NIGHTS [printed vertically on the right]
  //   B... A... [vertical text on the left, mostly covered by ticket]
  //   FRIDAY DECEMBER 18, 1998
  //   EARLY ALL AGES SHOW
  //   DOORS AT 6:00 PM/SHOW AT 6:30 PM
  //   [ticket laid on top: "RANCH BOWL PRESENTS THE URGE SPECIAL GUEST TBA ALL AGES 1600 S. 72ND STREET FRI DEC 18 1998 6:00 PM · GENADM GA3 33 A 13.00 · ADMIT ONE PERSON"]
  //   [generic Ranch Bowl info filled in: support line, name split onto two lines, venue, address, ticket note, 3 ticket line(s)]
  ranchShow({
    topline: "NICK & ERIC'S PRESENTS",
    headlineOne: "THE",
    headlineTwo: "URGE",
    headlineThree: "",
    guestLabel: "2 BIG NIGHTS",
    supportAct: "RANCH BOWL SHOW",
    dateLine: "FRIDAY DECEMBER 18, 1998",
    agesLine: "EARLY ALL AGES SHOW",
    doorsLine: "DOORS AT 6:00 PM",
    showLine: "SHOW AT 6:30 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "ADVANCE TICKETS AVAILABLE AT TICKETMASTER OUTLETS",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: COLLECTIVE SOUL
  //   ATLANTIC RECORDS RECORDING ARTIST
  //   COLLECTIVE SOUL
  //   SPECIAL GUEST: TBA
  //   MONDAY, MAY 30, 1994
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $6.50 / DAY OF SHOW $7.50
  //   DOORS OPEN 8:00 PM / SHOW STARTS 9:00PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  ranchShow({
    topline: "ATLANTIC RECORDS RECORDING ARTIST",
    headlineOne: "COLLECTIVE",
    headlineTwo: "SOUL",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "TBA",
    dateLine: "MONDAY, MAY 30, 1994",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADVANCE TICKETS $6.50 / DAY OF SHOW $7.50",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS,",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: DOWN
  //   "An Evening With"
  //   Down [logo]
  //   [band photo, fleur-de-lis]
  //   [Nick & Eric's logo]
  //   SUNDAY AUGUST 18TH
  //   18 AND OVER - $20 ADVANCE $22 DAY OF SHOW - DOORS 8PM SHOW 9PM
  //   RANCH BOWL
  //   1600 South 72nd Street
  //   Omaha, Nebraska (402) 393-0900
  //   TICKET CENTERS [list unreadable]
  //   Omaha/Council Bluffs 402-422-1212 [uncertain]
  //   Lincoln 402-475-1212 [uncertain]
  //   WWW.TICKETMASTER.COM [uncertain]
  //   MEGAWATT [uncertain] [other sponsor logos unreadable]
  //   [year 2002 added: full show video "Down (live) - Ranch Bowl - Omaha, NE, USA (Aug. 18, 2002)"]
  //   [generic Ranch Bowl info filled in: guest lines]
  ranchShow({
    lineOneScale: "115",
    topline: "\"An Evening With\"",
    headlineOne: "Down",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "ONE NIGHT ONLY",
    supportAct: "RANCH BOWL SHOW",
    dateLine: "SUNDAY AUGUST 18TH, 2002",
    agesLine: "18 AND OVER",
    doorsLine: "DOORS 8PM",
    showLine: "SHOW 9PM",
    venueLine: "RANCH BOWL",
    addressLine: "1600 South 72nd Street  -  Omaha, Nebraska (402) 393-0900",
    noteLine: "$20 ADVANCE $22 DAY OF SHOW",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "Omaha/Council Bluffs 402-422-1212  Lincoln 402-475-1212",
    tinyLineThree: "WWW.TICKETMASTER.COM"
  }),
  // Transcription: OMAHA METAL FEST 1
  //   Pitt Ripply presents
  //   Omaha metal fest 1
  //   [band logos:]
  //   [unreadable]
  //   Faith In Pain [uncertain]
  //   FACE CAGE
  //   [unreadable]
  //   [uncertain: Parasitic] Possession
  //   Chrome Semic FIASCO [uncertain]
  //   Dirtfedd [uncertain]
  //   HATRED
  //   Drawn In Sorrow
  //   Coff Drops [uncertain]
  //   Idle Apathy
  //   Narcotic Self
  //   Indrid Cold
  //   RANCH BOWL
  //   1606 S. 72nd St Omaha, NE
  //   (402) 393-0900
  //   [sponsor logos unreadable]
  //   WWW.RANCHBOWL.COM [uncertain]
  //   saturday april 12
  //   $10
  //   ALL AGES
  //   DOORS AT NOON
  //   SHOW AT 12:30PM
  //   [generic Ranch Bowl info filled in: guest label, 2 ticket line(s)]
  ranchShow({
    lineOneScale: "135",
    lineTwoScale: "135",
    topline: "Pitt Ripply presents",
    headlineOne: "Omaha metal",
    headlineTwo: "fest 1",
    headlineThree: "",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "Faith In Pain / FACE CAGE / Parasitic Possession / Chrome Semic FIASCO / Dirtfedd / HATRED / Drawn In Sorrow / Coff Drops / Idle Apathy / Narcotic Self / Indrid Cold",
    dateLine: "saturday april 12",
    agesLine: "ALL AGES",
    doorsLine: "DOORS AT NOON",
    showLine: "SHOW AT 12:30PM",
    venueLine: "RANCH BOWL",
    addressLine: "1606 S. 72nd St Omaha, NE  -  (402) 393-0900",
    noteLine: "$10",
    tinyLineOne: "WWW.RANCHBOWL.COM",
    tinyLineTwo: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineThree: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: NIGHTMARE
  //   [collage captions:]
  //   THERE'S JUST SO MUCH... [cut off]
  //   DREDGING THROUGH THE HARD TIMES
  //   WHAT HAS HAPPENED TO THE WORLD WE LIVE IN?
  //   I MUST TELL YOU WHAT WENT ON...
  //   [I] CAN FEEL THE BLOOD RUSH TO MY HEAD.
  //   NIGHTMARE
  //   THURS, NOV 5 | NIGHTMARE
  //   RANCH BOWL | SOCIAL DECAY
  //   [$]5 AT DOOR ALL AGES! | HOUSE OF COMMONS
  //   [D]OORS 7PM SHOW 8PM | HEAVY CHEESECAKE
  //   NO MORE WHIPS ON MY BACK.
  //   WAS IT A DREAM? I COULDN'T TELL
  //   DO YOU LOVE ME OR AM I JUST HIRED?
  //   UNLEASHING ALL MY ANGER
  //   [bottom edge unreadable]
  //   [generic Ranch Bowl info filled in: guest label, top line, address, 3 ticket line(s)]
  ranchShow({
    lineOneScale: "135",
    topline: "RANCH BOWL ENTERTAINMENT CENTER PRESENTS",
    headlineOne: "NIGHTMARE",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "SOCIAL DECAY / HOUSE OF COMMONS / HEAVY CHEESECAKE",
    dateLine: "THURS, NOV 5",
    agesLine: "ALL AGES!",
    doorsLine: "DOORS 7PM",
    showLine: "SHOW 8PM",
    venueLine: "RANCH BOWL",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "$5 AT DOOR",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: KING'S X
  //   ATLANTIC RECORDS RECORDING ARTIST
  //   [photo]
  //   KING'S X
  //   SPECIAL GUEST: JRZ System
  //   WEDNESDAY, APRIL 27, 1994
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $10.75 / DAY OF SHOW $11.75
  //   DOORS OPEN 8:00 PM / SHOW STARTS 9:00PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  ranchShow({
    topline: "ATLANTIC RECORDS RECORDING ARTIST",
    headlineOne: "KING'S",
    headlineTwo: "X",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "JRZ System",
    dateLine: "WEDNESDAY, APRIL 27, 1994",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADVANCE TICKETS $10.75 / DAY OF SHOW $11.75",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS,",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: PRONG
  //   EPIC RECORDS RECORDING ARTIST
  //   PRONG [photo]
  //   SPECIAL GUEST: COURSE OF EMPIRE
  //   TUESDAY, APRIL 26, 1994
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $9.50 / DAY OF SHOW $10.50
  //   DOORS OPEN 8:00 PM / SHOW STARTS 9:00PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  ranchShow({
    lineOneScale: "120",
    topline: "EPIC RECORDS RECORDING ARTIST",
    headlineOne: "PRONG",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "COURSE OF EMPIRE",
    dateLine: "TUESDAY, APRIL 26, 1994",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADVANCE TICKETS $9.50 / DAY OF SHOW $10.50",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS,",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: FIGHT
  //   [photo]
  //   EPIC RECORDS RECORDING ARTIST
  //   FIGHT
  //   FEATURING: ROB HALFORD
  //   SPECIAL GUEST: TO BE ANNOUNCED
  //   WEDNESDAY, FEBRUARY 2, 1994
  //   ALL AGES WELCOME
  //   ADV. TIX $11.50 / DOS $12.50
  //   DOORS OPEN 8:00PM / SHOW STARTS 9:00PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, [I]NCLUDING YOUNKERS, HOMERS, PICKLES AND THE O[M]AHA CIVIC AUDITORIUM BOX OFFICE
  //   [RAN]C[H] BOWL ENTERTAIN[M]ENT CENTER [torn]
  //   93K-ROCK
  ranchShow({
    lineOneScale: "115",
    topline: "EPIC RECORDS RECORDING ARTIST",
    headlineOne: "FIGHT",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "FEATURING: ROB HALFORD",
    supportAct: "SPECIAL GUEST: TO BE ANNOUNCED",
    dateLine: "WEDNESDAY, FEBRUARY 2, 1994",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00PM",
    showLine: "SHOW STARTS 9:00PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADV. TIX $11.50 / DOS $12.50",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING YOUNKERS, HOMERS, PICKLES AND",
    tinyLineThree: "THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: EVERY MOTHERS NIGHTMARE
  //   [photo]
  //   ARISTA RECORDING ARTISTS
  //   EVERY MOTHERS NIGHTMARE
  //   SPECIAL GUEST: TBA
  //   SUNDAY, MARCH 7, 1993
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $5.75 DAY OF SHOW $6.75
  //   DOORS OPEN 8:00 PM SHOW STARTS 9:00 PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  ranchShow({
    lineOneScale: "130",
    lineTwoScale: "130",
    topline: "ARISTA RECORDING ARTISTS",
    headlineOne: "EVERY MOTHERS",
    headlineTwo: "NIGHTMARE",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "TBA",
    dateLine: "SUNDAY, MARCH 7, 1993",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADVANCE TICKETS $5.75 DAY OF SHOW $6.75",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS,",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: GHOST OF AN AMERICAN AIRMAN
  //   HOLLYWOOD REOCRDS RECORDING ARTIST [misspelled on the poster]
  //   GHOST OF AN AMERICAN AIRMAN
  //   THURSDAY, NOVEMBER 11, 1993
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $5.00 / DAY OF SHOW $6.00
  //   DOORS 8:00 PM / SHOW 9:00 PM
  //   [TI]CKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER [TI]CKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   [R]ANCH BOWL
  //   93K-ROCK
  //   [generic Ranch Bowl info filled in: guest lines]
  ranchShow({
    lineOneScale: "135",
    lineTwoScale: "135",
    topline: "HOLLYWOOD REOCRDS RECORDING ARTIST",
    headlineOne: "GHOST OF AN",
    headlineTwo: "AMERICAN AIRMAN",
    headlineThree: "",
    guestLabel: "ONE NIGHT ONLY",
    supportAct: "RANCH BOWL SHOW",
    dateLine: "THURSDAY, NOVEMBER 11, 1993",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS 8:00 PM",
    showLine: "SHOW 9:00 PM",
    venueLine: "RANCH BOWL",
    addressLine: "93K-ROCK",
    noteLine: "ADVANCE TICKETS $5.00 / DAY OF SHOW $6.00",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS,",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: ACCEPT (this poster was posted twice)
  //   CMC INTERNATIONAL RECORDS RECORDING ARTIST
  //   ACCEPT
  //   [photo]
  //   WITH SPECIAL GUESTS:
  //   I.R.S. RECORDS RECORDING ARTIST
  //   LILLIAN AXE
  //   [photo]
  //   & STRIP MIND
  //   THURSDAY OCTOBER 28, 1993
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $12.50 DAY OF SHOW $13.50
  //   DOORS OPEN 8:00 PM SHOW STARTS 9:00 PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  ranchShow({
    lineOneScale: "135",
    topline: "CMC INTERNATIONAL RECORDS RECORDING ARTIST",
    headlineOne: "ACCEPT",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "WITH SPECIAL GUESTS:",
    supportAct: "I.R.S. RECORDS RECORDING ARTIST LILLIAN AXE & STRIP MIND",
    dateLine: "THURSDAY OCTOBER 28, 1993",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADVANCE TICKETS $12.50 DAY OF SHOW $13.50",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS,",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: SAIGON KICK
  //   SAIGON KICK
  //   [photo]
  //   SPECIAL GUEST: TBA
  //   WEDNESDAY, NOVEMBER 18, 1992
  //   DOORS 8:00 SHOW 9:00
  //   ADVANCE TICKETS $9.75; DAY OF SHOW $10.75
  //   ALL AGES WELCOME
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER LOCATIONS, INCLUDING, YOUNKERS, HOMERS, PICKLES AND THE OMAHA CIVIC BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  //   [generic Ranch Bowl info filled in: top line, 1 ticket line(s)]
  ranchShow({
    topline: "RANCH BOWL ENTERTAINMENT CENTER PRESENTS",
    headlineOne: "SAIGON",
    headlineTwo: "KICK",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "TBA",
    dateLine: "WEDNESDAY, NOVEMBER 18, 1992",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS 8:00",
    showLine: "SHOW 9:00",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADVANCE TICKETS $9.75; DAY OF SHOW $10.75",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER LOCATIONS,",
    tinyLineTwo: "INCLUDING, YOUNKERS, HOMERS, PICKLES AND THE OMAHA CIVIC BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: LOVE ON ICE / ELECTRIC LOVE HOGS / NIGHTMARE
  //   INTERSCOPE RECORDS RECORDING ARTISTS
  //   LOVE ON ICE
  //   ELECTRIC LOVE HOGS
  //   & NIGHTMARE
  //   MONDAY, JUNE 22, 1992
  //   ALL AGES WELCOME
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   1600 S. 72nd Street, Omaha, NE
  //   [D]OORS OPEN 7:30PM SHOW TIME 9:00PM
  //   [A]DVANCE TICKETS $6.75 DAY OF SHOW $7.75
  //   [T]ICKETS AVAILABLE AT THE RANCH BOWL ANDALL TICKETMASTER [TIC]KET CENTERS INCLUDING YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM
  //   [RAN]CH BOWL [ENTER]TAINMENT CENTER [corner torn]
  //   93K ROCK
  //   [generic Ranch Bowl info filled in: guest lines]
  ranchShow({
    lineOneScale: "135",
    lineTwoScale: "135",
    topline: "INTERSCOPE RECORDS RECORDING ARTISTS",
    headlineOne: "LOVE ON ICE",
    headlineTwo: "ELECTRIC LOVE HOGS",
    headlineThree: "",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "NIGHTMARE",
    dateLine: "MONDAY, JUNE 22, 1992",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 7:30PM",
    showLine: "SHOW TIME 9:00PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 S. 72nd Street, Omaha, NE",
    noteLine: "ADVANCE TICKETS $6.75 DAY OF SHOW $7.75",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL ANDALL",
    tinyLineTwo: "TICKETMASTER TICKET CENTERS INCLUDING YOUNKERS,",
    tinyLineThree: "PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM"
  }),
  // Transcription: MARLYNN MANSON (spelled this way on the poster)
  //   I[N]TERSCOPE RECORDING AR[TIST] [partly obscured]
  //   MARLYNN MANSON
  //   SPECIAL GUESTS:
  //   [photo] Clutch [logo]
  //   AND THE ZEROS
  //   SUNDAY OCTOBER 15, 1995
  //   DOORS OPEN 8:00PM / SHOW STARTS 9:00PM
  //   OVER 21 SHOW
  //   TICKETS $11.00 ADV $13.00 DAY OF SHOW
  //   TICKETS AVAILABLE AT THE RANCH BOWL, AND ALL TICKETMASTER TICKET OUTLETS INCLUDING: YOUNKERS, PICKLES, HOMERS AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE.
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   933K-ROCK
  //   OMAHA'S NEW ROCK ALTERNATIVE
  ranchShow({
    topline: "INTERSCOPE RECORDING ARTIST",
    headlineOne: "MARLYNN",
    headlineTwo: "MANSON",
    headlineThree: "",
    guestLabel: "SPECIAL GUESTS:",
    supportAct: "Clutch AND THE ZEROS",
    dateLine: "SUNDAY OCTOBER 15, 1995",
    agesLine: "OVER 21 SHOW",
    doorsLine: "DOORS OPEN 8:00PM",
    showLine: "SHOW STARTS 9:00PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "933K-ROCK  -  OMAHA'S NEW ROCK ALTERNATIVE",
    noteLine: "TICKETS $11.00 ADV $13.00 DAY OF SHOW",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL, AND ALL",
    tinyLineTwo: "TICKETMASTER TICKET OUTLETS INCLUDING: YOUNKERS,",
    tinyLineThree: "PICKLES, HOMERS AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE."
  }),
  // Transcription: WHITE ZOMBIE
  //   [photo]
  //   [label name covered by torn paper] RECORDS RECORDING ARTIST
  //   WHITE ZOMBIE
  //   SPECIAL GUEST: MONSTER MAGNET
  //   TUESDAY, MARCH 9, 1993
  //   18 AND OVER ONLY
  //   [generic Ranch Bowl info filled in: doors, show, venue, address, ticket note, 3 ticket line(s)]
  ranchShow({
    topline: "GEFFEN RECORDS RECORDING ARTIST",
    headlineOne: "WHITE",
    headlineTwo: "ZOMBIE",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "MONSTER MAGNET",
    dateLine: "TUESDAY, MARCH 9, 1993",
    agesLine: "18 AND OVER ONLY",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "ADVANCE TICKETS AVAILABLE AT TICKETMASTER OUTLETS",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: CANDLEBOX - SEPTEMBER 1993
  //   [photo]
  //   WARNER BROTHERS RECORDS RECORDING ARTIST
  //   CANDLEBOX
  //   SPECIAL GUEST: TO BE ANNOUNCED
  //   THURSDAY SEPTEMBER 16, 1993
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $5.50 / DAY OF SHOW $6.50
  //   DOORS OPEN 8:00 PM / SHOW STARTS 9:00PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  ranchShow({
    lineOneScale: "135",
    topline: "WARNER BROTHERS RECORDS RECORDING ARTIST",
    headlineOne: "CANDLEBOX",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "TO BE ANNOUNCED",
    dateLine: "THURSDAY SEPTEMBER 16, 1993",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADVANCE TICKETS $5.50 / DAY OF SHOW $6.50",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS,",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: TYPE O NEGATIVE
  //   [Nick & Eric's logo] PRESENTS
  //   TYPE "O" NEGATIVE
  //   SPECIAL GUESTS:
  //   SISTER MACHINE GUN
  //   SUNDAY FEBRUARY 2, 1997
  //   ALL AGES SHOW
  //   TICKETS: $14.00 ADVANCE
  //   $15.00 DAY OF SHOW
  //   DOORS: 8:00 PM/SHOW 9:00 PM
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS
  //   [generic Ranch Bowl info filled in: address, 2 ticket line(s)]
  ranchShow({
    topline: "NICK & ERIC'S PRESENTS",
    headlineOne: "TYPE \"O\"",
    headlineTwo: "NEGATIVE",
    headlineThree: "",
    guestLabel: "SPECIAL GUESTS:",
    supportAct: "SISTER MACHINE GUN",
    dateLine: "SUNDAY FEBRUARY 2, 1997",
    agesLine: "ALL AGES SHOW",
    doorsLine: "DOORS: 8:00 PM",
    showLine: "SHOW 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "TICKETS: $14.00 ADVANCE  $15.00 DAY OF SHOW",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: STEELHEART
  //   [photo]
  //   MCA RECORDING ARTISTS
  //   STEELHEART
  //   SPECIAL GUEST: TBA
  //   SUNDAY, OCTOBER 11, 1992
  //   ALL AGES WELCOME
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   1600 S. 72nd Street, Omaha, NE
  //   DOORS OPEN 8:00PM SHOW TIME 9:00PM
  //   ADV. TICKETS $10.75 DAY OF SHOW $11.75
  //   TICKETS AVAILABLE AT THE RANCH BOWL ANDALL TICKETMASTER TICKET CENTERS INCLUDING YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K ROCK
  //   [generic Ranch Bowl info filled in: 1 ticket line(s)]
  ranchShow({
    lineOneScale: "135",
    topline: "MCA RECORDING ARTISTS",
    headlineOne: "STEELHEART",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "TBA",
    dateLine: "SUNDAY, OCTOBER 11, 1992",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00PM",
    showLine: "SHOW TIME 9:00PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 S. 72nd Street, Omaha, NE",
    noteLine: "ADV. TICKETS $10.75 DAY OF SHOW $11.75",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL ANDALL TICKETMASTER TICKET CENTERS",
    tinyLineTwo: "INCLUDING YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: JUROR 13 / FORNEVER
  //   JUROR 13 [logo]
  //   ForNever
  //   Dementia & Size 13
  //   At
  //   The Ranch Bowl Entertainment Center
  //   1600 S. 72nd Street • Omaha, NE • 393-0900
  //   Monday June 21st
  //   Doors Open At 8pm
  //   Advanced Tickets $2
  //   Day of Show $4
  //   Check out Fornever on the Web at: WWW.FORNEVER.COM
  //   [generic Ranch Bowl info filled in: guest label, ages, show, top line, 2 ticket line(s)]
  ranchShow({
    topline: "RANCH BOWL ENTERTAINMENT CENTER PRESENTS",
    headlineOne: "JUROR 13",
    headlineTwo: "ForNever",
    headlineThree: "",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "Dementia & Size 13",
    dateLine: "Monday June 21st",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "Doors Open At 8pm",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "The Ranch Bowl Entertainment Center",
    addressLine: "1600 S. 72nd Street • Omaha, NE • 393-0900",
    noteLine: "Advanced Tickets $2  Day of Show $4",
    tinyLineOne: "Check out Fornever on the Web at: WWW.FORNEVER.COM",
    tinyLineTwo: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineThree: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: GIN BLOSSOMS
  //   SHUT UP AND SMOKE.
  //   [band photo]
  //   gin blossoms [script]
  //   [album art: "gin blossoms NEW MISERABLE EXPERIENCE"; small text unreadable]
  //   IN CONCERT
  //   Brought to you by A&M [logo] and INsider
  //   WEDNESDAY, APRIL 28, 1993
  //   AT THE RANCH BOWL, 1600 S. 72ND ST.
  //   DOORS 8:00PM SHOW 9:00PM
  //   SPECIAL GUESTS: CRASH VEGAS & LOST LUGGAGE
  //   ADV TICKETS 5.75
  //   [generic Ranch Bowl info filled in: name split onto two lines, address, 2 ticket line(s)]
  ranchShow({
    topline: "SHUT UP AND SMOKE.",
    headlineOne: "gin",
    headlineTwo: "blossoms",
    headlineThree: "",
    guestLabel: "SPECIAL GUESTS:",
    supportAct: "CRASH VEGAS & LOST LUGGAGE",
    dateLine: "WEDNESDAY, APRIL 28, 1993",
    agesLine: "IN CONCERT",
    doorsLine: "DOORS 8:00PM",
    showLine: "SHOW 9:00PM",
    venueLine: "AT THE RANCH BOWL, 1600 S. 72ND ST.",
    addressLine: "OMAHA, NE  -  (402) 393-0900",
    noteLine: "ADV TICKETS 5.75",
    tinyLineOne: "Brought to you by A&M and INsider",
    tinyLineTwo: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineThree: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: BLIND MELON
  //   [photo]
  //   CAPITOL RECORDS RECORDING ARTIST
  //   BLIND MELON
  //   SPECIAL GUEST: FIFTH OF MAY & NO LEFT STONE
  //   MONDAY, FEBRUARY 22, 1993
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $7.50 DAY OF SHOW $8.50
  //   DOORS OPEN 7:30 PM SHOW STARTS 8:30PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  ranchShow({
    topline: "CAPITOL RECORDS RECORDING ARTIST",
    headlineOne: "BLIND",
    headlineTwo: "MELON",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "FIFTH OF MAY & NO LEFT STONE",
    dateLine: "MONDAY, FEBRUARY 22, 1993",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 7:30 PM",
    showLine: "SHOW STARTS 8:30PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADVANCE TICKETS $7.50 DAY OF SHOW $8.50",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS,",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: CANDLEBOX - NOVEMBER 1993
  //   [photo]
  //   WARNER BROTHERS RECORDS RECORDING ARTIST
  //   CANDLEBOX
  //   SPECIAL GUEST: GRETA
  //   TUESDAY, NOVEMBER 30, 1993
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $8.75 / DAY OF SHOW $9.75
  //   DOORS OPEN 8:00 PM / SHOW STARTS 9:00PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  ranchShow({
    lineOneScale: "135",
    topline: "WARNER BROTHERS RECORDS RECORDING ARTIST",
    headlineOne: "CANDLEBOX",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "GRETA",
    dateLine: "TUESDAY, NOVEMBER 30, 1993",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADVANCE TICKETS $8.75 / DAY OF SHOW $9.75",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS,",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: INJECTED - "11/20" (carousel, slide 2; slide 1 is a text story)
  //   injected [logo]
  //   [five small band photos]
  //   [photo: guitar with "injected" on it]
  //   [tiny text, lower right of photo: uncertain: www.injected.net]
  //   APPEARING AT: [printed]
  //   [handwritten:] RANCHBOWL $6
  //   11/20 7pm
  //   [no year shown]
  //   [generic Ranch Bowl info filled in: ages, doors, show, top line, venue, address, ticket note, 3 ticket line(s)]
  ranchShow({
    lineOneScale: "135",
    topline: "RANCH BOWL ENTERTAINMENT CENTER PRESENTS",
    headlineOne: "injected",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "APPEARING AT:",
    supportAct: "RANCHBOWL $6",
    dateLine: "11/20 7pm",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "ADVANCE TICKETS AVAILABLE AT TICKETMASTER OUTLETS",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: ASPHALT BALLET - APRIL 1, 1993 (posted twice)
  //   VIRGIN RECORDS RECORDING ARTIST
  //   ASPHALT
  //   BALLET
  //   SPECIAL GUEST: TIGHT FIT
  //   THURSDAY, APRIL 1, 1993
  //   ALL AGES WELCOME
  //   FREE ADMISSION
  //   DOORS OPEN 8:00 PM   SHOW STARTS 9:00 PM
  //   RANCH BOWL 93K-ROCK
  //   ENTERTAINMENT CENTER [cut off in one post; fully visible in the second post]
  //   [generic Ranch Bowl info filled in: 3 ticket line(s)]
  ranchShow({
    topline: "VIRGIN RECORDS RECORDING ARTIST",
    headlineOne: "ASPHALT",
    headlineTwo: "BALLET",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "TIGHT FIT",
    dateLine: "THURSDAY, APRIL 1, 1993",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL 93K-ROCK",
    addressLine: "ENTERTAINMENT CENTER",
    noteLine: "FREE ADMISSION",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: WHITE TRASH - MAY 5, 1994
  //   ELEKTRA RECORDS REC[ORDING ARTIST] [top line cut off]
  //   WHITE
  //   TRASH
  //   SPECIAL GUEST: TBA
  //   THURSDAY, MAY 5, 1994
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $5.50 / DAY OF SHOW $6.50
  //   DOORS OPEN 8:00 PM / SHOW STARTS 9:00PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  ranchShow({
    topline: "ELEKTRA RECORDS RECORDING ARTIST",
    headlineOne: "WHITE",
    headlineTwo: "TRASH",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "TBA",
    dateLine: "THURSDAY, MAY 5, 1994",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADVANCE TICKETS $5.50 / DAY OF SHOW $6.50",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS,",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: WARRANT - JANUARY 23, 1994
  //   [faint line above band name, unreadable]
  //   WARRANT
  //   [band photo]
  //   SPECIAL GUEST: SAVAGE GRACE
  //   [band photo]
  //   SUNDAY, JANUARY 23, 1994
  //   ALL AGES WELCOME
  //   ADV. TIX $11.75 / DOS $12.75
  //   DOORS OPEN 8:00 / SHOW STARTS 9:30
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER OUTLETS, INCLUDING YOUNKERS, HOMERS, PICKLES, AND THE OMAHA CIVIC AUDITORIUM
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  //   [generic Ranch Bowl info filled in: top line, 1 ticket line(s)]
  ranchShow({
    lineOneScale: "135",
    topline: "RANCH BOWL ENTERTAINMENT CENTER PRESENTS",
    headlineOne: "WARRANT",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "SAVAGE GRACE",
    dateLine: "SUNDAY, JANUARY 23, 1994",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00",
    showLine: "SHOW STARTS 9:30",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADV. TIX $11.75 / DOS $12.75",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER OUTLETS,",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMERS, PICKLES, AND THE OMAHA CIVIC AUDITORIUM",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: STONE TEMPLE PILOTS - NOVEMBER 14, 1992 (blue poster)
  //   [band photo]
  //   STONE TEMPLE
  //   PILOTS
  //   SPECIAL GUEST: TBA
  //   SPECIAL EARLY SHOW
  //   SATURDAY, NOVEMBER 14, 1992
  //   DOORS 6:15   SHOW 6:45
  //   ALL AGES WELCOME
  //   NICKS ERIC'S WILL RE-OPEN AT 9:15 WITH FINEST HOUR FOR THE 21 AND OVER CROWD
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   1600 S. 72ND ST., OMAHA, NE
  //   ADVANCE TICKETS $5.75; DAY OF SHOW $6.75
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER LOCATIONS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  //   [generic Ranch Bowl info filled in: top line]
  ranchShow({
    lineOneScale: "135",
    lineTwoScale: "135",
    paperColor: "blue",
    topline: "RANCH BOWL ENTERTAINMENT CENTER PRESENTS",
    headlineOne: "STONE TEMPLE",
    headlineTwo: "PILOTS",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST: TBA",
    supportAct: "SPECIAL EARLY SHOW",
    dateLine: "SATURDAY, NOVEMBER 14, 1992",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS 6:15",
    showLine: "SHOW 6:45",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 S. 72ND ST., OMAHA, NE",
    noteLine: "ADVANCE TICKETS $5.75; DAY OF SHOW $6.75",
    tinyLineOne: "NICKS ERIC'S WILL RE-OPEN AT 9:15 WITH FINEST HOUR FOR THE 21 AND OVER CROWD",
    tinyLineTwo: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER LOCATIONS, INCLUDING,",
    tinyLineThree: "YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: BROTHER CANE - JULY 6, 1993
  //   VIRGIN RECORDS RECORDING ARTIST
  //   BROTHER CANE
  //   [band photo]
  //   SPECIAL GUEST: TO BE ANNOUNCED
  //   TUESDAY JULY 6, 1993
  //   ALL AGES WELCOME
  //   TICKETS $4.50 ADV/$5.50 D.O.S.
  //   DOORS OPEN 8:00 PM   SHOW STARTS 9:00 PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  ranchShow({
    topline: "VIRGIN RECORDS RECORDING ARTIST",
    headlineOne: "BROTHER",
    headlineTwo: "CANE",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "TO BE ANNOUNCED",
    dateLine: "TUESDAY JULY 6, 1993",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "TICKETS $4.50 ADV/$5.50 D.O.S.",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS,",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: TESTAMENT - APRIL 8, 1993
  //   [band photo]
  //   ATLANTIC RECORDS RECORDING ARTIST
  //   TESTAMENT
  //   SPECIAL GUESTS: GREEN JELLO & PRO-PAIN
  //   THURSDAY, APRIL 8, 1993
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $14.50   DAY OF SHOW $15.50
  //   DOORS OPEN 8:00 PM   SHOW STARTS 9:00 PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  ranchShow({
    lineOneScale: "135",
    topline: "ATLANTIC RECORDS RECORDING ARTIST",
    headlineOne: "TESTAMENT",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "SPECIAL GUESTS:",
    supportAct: "GREEN JELLO & PRO-PAIN",
    dateLine: "THURSDAY, APRIL 8, 1993",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADVANCE TICKETS $14.50   DAY OF SHOW $15.50",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS,",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: FASTER PUSSYCAT - AUGUST 31, 1992
  //   ELEKTRA RECORDING ARTISTS
  //   FASTER
  //   PUSSYCAT
  //   SPECIAL GUESTS:
  //   MY SISTER'S MACHINE
  //   MONDAY, AUGUST 31, 1992
  //   18 AND OVER
  //   [rest of poster torn off below this line]
  //   [generic Ranch Bowl info filled in: doors, show, venue, address, ticket note, 3 ticket line(s)]
  ranchShow({
    topline: "ELEKTRA RECORDING ARTISTS",
    headlineOne: "FASTER",
    headlineTwo: "PUSSYCAT",
    headlineThree: "",
    guestLabel: "SPECIAL GUESTS:",
    supportAct: "MY SISTER'S MACHINE",
    dateLine: "MONDAY, AUGUST 31, 1992",
    agesLine: "18 AND OVER",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "ADVANCE TICKETS AVAILABLE AT TICKETMASTER OUTLETS",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: HOLLOWED CD RELEASE PARTY - SATURDAY DECEMBER 14 (no year shown)
  //   [Nick & Eric's logo] PRESENTS:
  //   [several handwritten autographs across the top, unreadable]
  //   hollowed
  //   CD RELEASE PARTY
  //   [artwork: circle-and-cross symbol]
  //   CHARACTER ZERO
  //   TRUTH IN RUIN
  //   DIRT FEDD
  //   SATURDAY DECEMBER 14
  //   ALL AGES - DOORS AT 7 - SHOW AT 8
  //   $8 INCLUDES CD
  //   $5 SHOW ONLY
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   1600 South 72nd Street
  //   Omaha, NE - (402) 393-0900
  //   WWW.RANCHBOWL.COM
  //   [logos:] SLAM OMAHA | Budweiser | HOMER'S | [uncertain: BEANEHEAD] GRAPHICS
  //   TICKETMASTER Ticket centers:
  //   Omaha: Bakers, Younkers, Ranch Bowl & Omaha Civic Auditorium Box Office
  //   Council Bluffs: Hy-Vee
  //   Lincoln: [uncertain: Russ's] Markets, Younkers, NE Union & Pershing Auditorium Box Offices
  //   Omaha/Council Bluffs 402.422.1212
  //   Lincoln 402.475.1212
  //   online www.ticketmaster.com
  //   [year 2002 added: Dec 14 fell on a Saturday in 1996 and 2002; Dirtfedd formed April 2002, so 2002]
  //   [generic Ranch Bowl info filled in: guest label]
  ranchShow({
    lineOneScale: "130",
    lineTwoScale: "130",
    topline: "NICK & ERIC'S PRESENTS:",
    headlineOne: "hollowed",
    headlineTwo: "CD RELEASE PARTY",
    headlineThree: "",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "CHARACTER ZERO / TRUTH IN RUIN / DIRT FEDD",
    dateLine: "SATURDAY DECEMBER 14, 2002",
    agesLine: "ALL AGES",
    doorsLine: "DOORS AT 7",
    showLine: "SHOW AT 8",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 South 72nd Street  -  Omaha, NE - (402) 393-0900",
    noteLine: "$8 INCLUDES CD  $5 SHOW ONLY",
    tinyLineOne: "TICKETMASTER Ticket centers: Omaha: Bakers, Younkers, Ranch Bowl & Omaha",
    tinyLineTwo: "Civic Auditorium Box Office Council Bluffs: Hy-Vee Lincoln: Russ's",
    tinyLineThree: "Markets, Younkers, NE Union & Pershing Auditorium Box Offices"
  }),
  // Transcription: TRIXTER (poster fragment, no date)
  //   MCA RECORDS RECORDING ARTISTS
  //   TRIXTER
  //   SPECIAL GUEST: TBA
  //   [only the top of the poster survives; everything below is torn off]
  //   [generic Ranch Bowl info filled in: date, ages, doors, show, venue, address, ticket note, 3 ticket line(s)]
  ranchShow({
    lineOneScale: "135",
    topline: "MCA RECORDS RECORDING ARTISTS",
    headlineOne: "TRIXTER",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "TBA",
    dateLine: "DATE TO BE ANNOUNCED",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "ADVANCE TICKETS AVAILABLE AT TICKETMASTER OUTLETS",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: EVERY MOTHERS NIGHTMARE - NOVEMBER 16, 1992
  //   [band photo]
  //   ARISTA RECORDING ARTISTS
  //   EVERY MOTHERS NIGHTMARE
  //   SPECIAL GUESTS: NIGHTMARE
  //   CELLOPHANE CEILING
  //   &
  //   RAGDOLL
  //   MONDAY, NOVEMBER 16, 1992
  //   DOORS 7:30 PM   SHOW 8:30 PM
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $5.75  DAY OF SHOW $6.75
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKET MASTER LOCATIONS INCLUDING YOUNKERS, PICKLE[S], HOMERS AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RA[NCH] BOWL 93K-ROCK [torn]
  //   [ENTERTAIN]MENT CENTER [torn]
  ranchShow({
    lineOneScale: "130",
    lineTwoScale: "130",
    topline: "ARISTA RECORDING ARTISTS",
    headlineOne: "EVERY MOTHERS",
    headlineTwo: "NIGHTMARE",
    headlineThree: "",
    guestLabel: "SPECIAL GUESTS:",
    supportAct: "NIGHTMARE / CELLOPHANE CEILING & RAGDOLL",
    dateLine: "MONDAY, NOVEMBER 16, 1992",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS 7:30 PM",
    showLine: "SHOW 8:30 PM",
    venueLine: "RANCH BOWL 93K-ROCK",
    addressLine: "ENTERTAINMENT CENTER",
    noteLine: "ADVANCE TICKETS $5.75  DAY OF SHOW $6.75",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKET",
    tinyLineTwo: "MASTER LOCATIONS INCLUDING YOUNKERS, PICKLES, HOMERS",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: [uncertain: LEAD] / FORNEVER - "THE END OF THE WORLD BEGINS" - WEDNESDAY, MAY 5TH (no year shown)
  //   THE END OF THE WORLD BEGINS
  //   WEDNESDAY, MAY 5TH
  //   AT THE
  //   RANCH BOWL
  //   WITH
  //   [uncertain: LEAD] [stylized band logo]
  //   ForNever
  //   AND
  //   Special Guest TBA
  //   $4
  //   All Ages
  //   8:30
  //   [background: mushroom cloud and pentagram artwork]
  //   [generic Ranch Bowl info filled in: show, address, 3 ticket line(s)]
  ranchShow({
    topline: "THE END OF THE WORLD BEGINS",
    headlineOne: "LEAD",
    headlineTwo: "ForNever",
    headlineThree: "",
    guestLabel: "AND",
    supportAct: "Special Guest TBA",
    dateLine: "WEDNESDAY, MAY 5TH",
    agesLine: "All Ages",
    doorsLine: "8:30",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "AT THE RANCH BOWL",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "$4",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: SAVATAGE - SEPTEMBER 1, 1993
  //   ATLANTIC RECORDS RECORDING ARTIST
  //   SAVATAGE
  //   SPECIAL GUEST: TO BE ANNOUNCED
  //   WEDNESDAY SEPTEMBER 1, 1993
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $8.50   DAY OF SHOW $9.50
  //   DOORS OPEN 8:00 PM   SHOW STARTS 9:00 PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  ranchShow({
    lineOneScale: "135",
    topline: "ATLANTIC RECORDS RECORDING ARTIST",
    headlineOne: "SAVATAGE",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "TO BE ANNOUNCED",
    dateLine: "WEDNESDAY SEPTEMBER 1, 1993",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93K-ROCK",
    noteLine: "ADVANCE TICKETS $8.50   DAY OF SHOW $9.50",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS,",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: WHITE ZOMBIE - JANUARY 29, 1994 (Mancuso Convention Hall)
  //   GEFFEN RECORDS RECORDING ARTIST
  //   WHITE ZOMBIE
  //   SPECIAL GUEST: PRONG
  //   SATURDAY, JANUARY 29, 1994
  //   ALL AGES WELCOME
  //   MANCUSO CONVENTION HALL
  //   ADV. TICKETS $17.50 / DOS $20
  //   DOORS OPEN 6:30 / SHOW STARTS 7:30
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER OUTLETS INCLUDING HOMERS, YOUNKERS, PICKLES AND THE OMAHA CIVIC AUDITORIUM
  //   [generic Ranch Bowl info filled in: city, 1 ticket line]
  ranchShow({
    topline: "GEFFEN RECORDS RECORDING ARTIST",
    headlineOne: "WHITE",
    headlineTwo: "ZOMBIE",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "PRONG",
    dateLine: "SATURDAY, JANUARY 29, 1994",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 6:30",
    showLine: "SHOW STARTS 7:30",
    venueLine: "MANCUSO CONVENTION HALL",
    addressLine: "OMAHA, NEBRASKA",
    noteLine: "ADV. TICKETS $17.50 / DOS $20",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER OUTLETS",
    tinyLineTwo: "INCLUDING HOMERS, YOUNKERS, PICKLES AND THE OMAHA CIVIC AUDITORIUM",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: DEFTONES - "SHOVE IT" - WEDNESDAY DECEMBER TENTH (no year shown)
  //   shove it
  //   deftones
  //   [one line of the song's lyrics printed across the poster here - not reproduced for copyright reasons]
  //   [photo]
  //   & LIMP BIZKIT
  //   WILL HAVEN
  //   live wednesday december tenth
  //   RANCH BOWL
  //   1600 S. 72nd omaha
  //   all ages welcome * $12 ticket
  //   Tickets available at the Ranch Bowl & all Ticket Master outlets
  //   [sponsor logos:] BRIAN PRODUCTIONS | Sprint | Sprint PCS | HOMER'S [small text above logo unreadable] | Budweiser CONCERT SERIES
  //   [year 1997 added: setlist.fm lists Deftones at the Ranch Bowl on December 10, 1997]
  //   [generic Ranch Bowl info filled in: doors, show, 2 ticket line(s)]
  ranchShow({
    lineOneScale: "135",
    topline: "shove it",
    headlineOne: "deftones",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "& LIMP BIZKIT",
    supportAct: "WILL HAVEN",
    dateLine: "live wednesday december tenth, 1997",
    agesLine: "all ages welcome",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL",
    addressLine: "1600 S. 72nd omaha",
    noteLine: "$12 ticket",
    tinyLineOne: "Tickets available at the Ranch Bowl & all Ticket Master outlets",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: FIREHOSE - MAY 10, 1993
  //   CAPRICORN RECORDS RECORDING ARTIST
  //   fIREHOSE
  //   SPECIAL GUEST: BAZOOKA
  //   MONDAY, MAY 10, 1993
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $10.75   DAY OF SHOW $11.75
  //   DOORS OPEN 8:00 PM   SHOW STARTS 9:00 PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL 93K-ROCK
  //   [tiny line under RANCH BOWL unreadable]
  //   [generic Ranch Bowl info filled in: address]
  ranchShow({
    lineOneScale: "135",
    topline: "CAPRICORN RECORDS RECORDING ARTIST",
    headlineOne: "fIREHOSE",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "BAZOOKA",
    dateLine: "MONDAY, MAY 10, 1993",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL 93K-ROCK",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "ADVANCE TICKETS $10.75   DAY OF SHOW $11.75",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS,",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: 311 - APRIL 29, 1993
  //   CAPRICORN RECORDING ARTIST
  //   311
  //   SPECIAL GUESTS: FEVER TREE & BEEF CURTAN
  //   THURSDAY, APRIL 29, 1993
  //   ALL AGES WELCOME
  //   ADVANCE TICKETS $6.50   DAY OF SHOW $7.50
  //   DOORS OPEN 8:00 PM   SHOW STARTS 9:00 PM
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL 93K-ROCK
  //   [generic Ranch Bowl info filled in: address]
  ranchShow({
    lineOneScale: "115",
    topline: "CAPRICORN RECORDING ARTIST",
    headlineOne: "311",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "SPECIAL GUESTS:",
    supportAct: "FEVER TREE & BEEF CURTAINS",
    dateLine: "THURSDAY, APRIL 29, 1993",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL 93K-ROCK",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "ADVANCE TICKETS $6.50   DAY OF SHOW $7.50",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS, INCLUDING, YOUNKERS, PICKLES, HOMERS,",
    tinyLineThree: "AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: CORROSION OF CONFORMITY / MACHINE HEAD - AUGUST 10, 1997
  //   CORROSION OF CONFORMITY
  //   machine head
  //   [drawing: spiked skull]
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   1600 So. 72nd STREET
  //   OMAHA, NE. 68124
  //   w/ DRAIN
  //   SUNDAY AUGUST 10, 1997
  //   ALL AGES SHOW
  //   $11.00 ADV./$12.00 DAY OF SHOW
  //   DOORS AT 8:00 PM/SHOW AT 9:00 PM
  //   [generic Ranch Bowl info filled in: guest label, top line, 3 ticket line(s)]
  ranchShow({
    lineOneScale: "120",
    lineTwoScale: "120",
    topline: "RANCH BOWL ENTERTAINMENT CENTER PRESENTS",
    headlineOne: "CORROSION OF",
    headlineTwo: "CONFORMITY",
    headlineThree: "",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "MACHINE HEAD / DRAIN",
    dateLine: "SUNDAY AUGUST 10, 1997",
    agesLine: "ALL AGES SHOW",
    doorsLine: "DOORS AT 8:00 PM",
    showLine: "SHOW AT 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 So. 72nd STREET  -  OMAHA, NE. 68124",
    noteLine: "$11.00 ADV./$12.00 DAY OF SHOW",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: NUCLEAR ASSAULT - APRIL 7, 1993
  //   NUCLEAR
  //   ASSAULT
  //   SPECIAL GUEST: DIABOLIC POSSESSION
  //   WEDNESDAY, APRIL 7, 1993
  //   ALL AGES WELCOME
  //   [top strip and everything below "ALL AGES WELCOME" cut off]
  //   [generic Ranch Bowl info filled in: doors, show, top line, venue, address, ticket note, 3 ticket line(s)]
  ranchShow({
    topline: "RANCH BOWL ENTERTAINMENT CENTER PRESENTS",
    headlineOne: "NUCLEAR",
    headlineTwo: "ASSAULT",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "DIABOLIC POSSESSION",
    dateLine: "WEDNESDAY, APRIL 7, 1993",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "ADVANCE TICKETS AVAILABLE AT TICKETMASTER OUTLETS",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: NEW MUSIC MONDAY (BITZ-N-PIECES / ABADON / LAST HOPE) - MARCH 29, 1993
  //   RANCH BOWL ENTERTAINMENT CENTER & 93K-ROCK
  //   PRESENT
  //   NEW MUSIC MONDAY
  //   MARCH 29, 1993
  //   FEATURING
  //   3 BANDS
  //   BITZ-N-PIECES
  //   ABADON
  //   AND
  //   LAST HOPE
  //   DOORS OPEN 8:00 PM   SHOW STARTS 8:30 PM
  //   TICKETS $5 AT DOOR
  //   ALL AGES WELCOME
  //   [generic Ranch Bowl info filled in: venue, address, 3 ticket line(s)]
  ranchShow({
    topline: "RANCH BOWL ENTERTAINMENT CENTER & 93K-ROCK PRESENT",
    headlineOne: "NEW MUSIC",
    headlineTwo: "MONDAY",
    headlineThree: "",
    guestLabel: "FEATURING 3 BANDS",
    supportAct: "BITZ-N-PIECES / ABADON AND LAST HOPE",
    dateLine: "MARCH 29, 1993",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 8:30 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "TICKETS $5 AT DOOR",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: BUZZO - FRIDAY MARCH 1ST, 2002
  //   BUZZO
  //   Gauge   Hollowed
  //   Second Coming   Cloaca
  //   Notch
  //   FRIDAY MARCH 1ST, 2002
  //   $6 w/ admission ticket
  //   $8 w/o admission ticket
  //   doors at 7PM
  //   show at 8PM
  //   At The Ranch Bowl
  //   [photo artwork]
  //   poster by: Skinsuit communications http://members.aol.com/SKsuit
  //   artwork by: Richard Borge
  //   [generic Ranch Bowl info filled in: guest label, ages, top line, address, 1 ticket line(s)]
  ranchShow({
    lineOneScale: "120",
    topline: "RANCH BOWL ENTERTAINMENT CENTER PRESENTS",
    headlineOne: "BUZZO",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "Gauge / Hollowed / Second Coming / Cloaca / Notch",
    dateLine: "FRIDAY MARCH 1ST, 2002",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "doors at 7PM",
    showLine: "show at 8PM",
    venueLine: "At The Ranch Bowl",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "$6 w/ admission ticket  $8 w/o admission ticket",
    tinyLineOne: "poster by: Skinsuit communications http://members.aol.com/SKsuit",
    tinyLineTwo: "artwork by: Richard Borge",
    tinyLineThree: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS"
  }),
  // Transcription: BANG TANGO - SEPTEMBER 12, 1992
  //   MCA RECORDING ARTISTS
  //   BANG
  //   TANGO
  //   SPECIAL GUEST: TO BE ANNOUNCED
  //   SATURDAY, SEPTEMBER 12, 1992
  //   ALL AGES WELCOME
  //   [rest of poster torn off below this line]
  //   [generic Ranch Bowl info filled in: doors, show, venue, address, ticket note, 3 ticket line(s)]
  ranchShow({
    topline: "MCA RECORDING ARTISTS",
    headlineOne: "BANG",
    headlineTwo: "TANGO",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST:",
    supportAct: "TO BE ANNOUNCED",
    dateLine: "SATURDAY, SEPTEMBER 12, 1992",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "ADVANCE TICKETS AVAILABLE AT TICKETMASTER OUTLETS",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: ANTHRAX - DECEMBER 10, 1995
  //   ELEKTRA RECORDING ARTISTS
  //   ANTHRAX
  //   [ANTHRAX printed vertically down both sides; the right-hand one reads upside down/reversed]
  //   [band photo]
  //   SPECIAL GUESTS: THE DEFTONES
  //   LIFE OF AGONY
  //   SUNDAY DECEMBER 10, 1995
  //   DOORS OPEN 8:00PM / SHOW STARTS 9:00PM
  //   ALL AGES WELCOME   TICKETS $15.00
  //   TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS INCLUDING: YOUNKERS, PICKLES, HOMERS AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93.3 K-ROCK
  //   OMAHA'S NEW ROCK ALTERNATIVE
  ranchShow({
    lineOneScale: "135",
    topline: "ELEKTRA RECORDING ARTISTS",
    headlineOne: "ANTHRAX",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "SPECIAL GUESTS:",
    supportAct: "THE DEFTONES / LIFE OF AGONY",
    dateLine: "SUNDAY DECEMBER 10, 1995",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00PM",
    showLine: "SHOW STARTS 9:00PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "93.3 K-ROCK  -  OMAHA'S NEW ROCK ALTERNATIVE",
    noteLine: "TICKETS $15.00",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER",
    tinyLineTwo: "TICKET OUTLETS INCLUDING: YOUNKERS, PICKLES, HOMERS AND",
    tinyLineThree: "THE OMAHA CIVIC AUDITORIUM BOX OFFICE"
  }),
  // Transcription: CANNIBAL CORPSE - SUNDAY APRIL 14TH (no year shown)
  //   [Nick & Eric's logo]
  //   CANNIBAL CORPSE
  //   [band photo over zombie artwork]
  //   WITH
  //   DARK FUNERAL
  //   PISSING RAZORS
  //   INCANTATION
  //   SUNDAY APRIL 14TH
  //   ALL AGES - $15 ADVANCE $17 DAY OF SHOW - DOORS 7PM SHOW 8PM
  //   RANCH BOWL
  //   1600 South 72nd Street
  //   Omaha, Nebraska (402) 393-0900
  //   TICKET CENTERS
  //   Omaha: Bakers, Younkers, Disc Jockey & Omaha Civic Auditorium Box Office
  //   Council Bluffs: Hy-Vee & Disc Jockey
  //   Lincoln: Russ's Markets, Younkers, NE Union & Pershing Auditorium Box Offices
  //   Omaha/Council Bluffs 402.422.1212
  //   Lincoln 402.475.1212
  //   ONLINE WWW.TICKETMASTER.COM
  //   [logos:] TICKETMASTER | SLAM OMAHA | Budweiser | HOMER'S | Sprint
  //   [year 2002 added: setlist.fm lists Cannibal Corpse at the Ranch Bowl on April 14, 2002]
  ranchShow({
    topline: "NICK & ERIC'S PRESENTS",
    headlineOne: "CANNIBAL",
    headlineTwo: "CORPSE",
    headlineThree: "",
    guestLabel: "WITH",
    supportAct: "DARK FUNERAL / PISSING RAZORS / INCANTATION",
    dateLine: "SUNDAY APRIL 14TH, 2002",
    agesLine: "ALL AGES",
    doorsLine: "DOORS 7PM",
    showLine: "SHOW 8PM",
    venueLine: "RANCH BOWL",
    addressLine: "1600 South 72nd Street  -  Omaha, Nebraska (402) 393-0900",
    noteLine: "$15 ADVANCE $17 DAY OF SHOW",
    tinyLineOne: "TICKET CENTERS Omaha: Bakers, Younkers, Disc Jockey & Omaha Civic",
    tinyLineTwo: "Auditorium Box Office Council Bluffs: Hy-Vee & Disc Jockey Lincoln:",
    tinyLineThree: "Russ's Markets, Younkers, NE Union & Pershing Auditorium Box Offices"
  }),
  // Transcription: STONE TEMPLE PILOTS - NOVEMBER 14, 1992 (pink poster, signed; different printing from the blue poster above)
  //   [band photo]
  //   STONE TEMPLE
  //   PILOTS
  //   SPECIAL GUEST: TBA
  //   SPECIAL EARLY SHOW
  //   SATURDAY, NOVEMBER 14, 1992
  //   DOORS 6:15   SHOW 6:45
  //   [poster torn below this line]
  //   [handwritten, left: "To Autumn [uncertain] / Fall, Winter, Summer." then a signature, unreadable]
  //   [handwritten across middle: "THANK YOU ------ STP"]
  //   [handwritten, lower middle: "To [unreadable]" with a signature, unreadable]
  //   [handwritten, right edge: one or two more signatures, unreadable]
  //   [generic Ranch Bowl info filled in: ages, top line, venue, address, ticket note, 3 ticket line(s)]
  ranchShow({
    lineOneScale: "135",
    lineTwoScale: "135",
    paperColor: "pink",
    topline: "RANCH BOWL ENTERTAINMENT CENTER PRESENTS",
    headlineOne: "STONE TEMPLE",
    headlineTwo: "PILOTS",
    headlineThree: "",
    guestLabel: "SPECIAL GUEST: TBA",
    supportAct: "SPECIAL EARLY SHOW",
    dateLine: "SATURDAY, NOVEMBER 14, 1992",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS 6:15",
    showLine: "SHOW 6:45",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 South 72nd Street  -  Omaha, NE",
    noteLine: "ADVANCE TICKETS AVAILABLE AT TICKETMASTER OUTLETS",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: SOUTHGANG - DECEMBER 9, 1992 (signed)
  //   [band photo]
  //   CAPITOL RECORDS RECORDING ARTISTS
  //   SOUTHGANG
  //   SPECIAL GUESTS: SLAMMIN' GLADYS
  //   WEDNESDAY, DECEMBER 9, 1992
  //   ALL AGES WELCOME
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   1600 S. 72nd Street, Omaha, NE
  //   DOORS OPEN 8:00PM   SHOW TIME 9:00PM
  //   ADV. TICKETS $7.75 DAY OF SHOW $8.75
  //   TICKETS AVAILABLE AT THE RANCH BOWL ANDALL TICKETMASTER TICKET CENTERS INCLUDING YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   93K-ROCK
  //   [handwritten in green marker: "[uncertain: Autumn] - U R SOOO PRETTY - OOH YES" (across the top) and "[uncertain: Autumn, get funky]" (lower left), plus two large signatures, unreadable]
  //   [generic Ranch Bowl info filled in: 1 ticket line(s)]
  ranchShow({
    lineOneScale: "135",
    topline: "CAPITOL RECORDS RECORDING ARTISTS",
    headlineOne: "SOUTHGANG",
    headlineTwo: "",
    headlineThree: "",
    guestLabel: "SPECIAL GUESTS:",
    supportAct: "SLAMMIN' GLADYS",
    dateLine: "WEDNESDAY, DECEMBER 9, 1992",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00PM",
    showLine: "SHOW TIME 9:00PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 S. 72nd Street, Omaha, NE",
    noteLine: "ADV. TICKETS $7.75 DAY OF SHOW $8.75",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL ANDALL TICKETMASTER TICKET CENTERS",
    tinyLineTwo: "INCLUDING YOUNKERS, PICKLES, HOMERS, AND THE OMAHA CIVIC AUDITORIUM",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  }),
  // Transcription: FORNEVER / SUTTER CAIN / LOWER CASE I - MONDAY MARCH 15TH (no year shown)
  //   RANCH BOWL ENTERTAINMENT CENTER
  //   1600 S. 72nd ST • OMAHA, NE • (402) 393-0900
  //   PRESENTS
  //   ForNever
  //   Sutter Cain
  //   Lower Case I
  //   Monday March 15th at 8pm
  //   Advance Tickets $2.00
  //   Day of Show $4.00
  //   [generic Ranch Bowl info filled in: 1 ticket line, guest lines, ages, doors, show, 2 ticket line(s)]
  ranchShow({
    topline: "PRESENTS",
    headlineOne: "ForNever",
    headlineTwo: "Sutter Cain",
    headlineThree: "",
    guestLabel: "WITH SPECIAL GUESTS",
    supportAct: "Lower Case I",
    dateLine: "Monday March 15th at 8pm",
    agesLine: "ALL AGES WELCOME",
    doorsLine: "DOORS OPEN 8:00 PM",
    showLine: "SHOW STARTS 9:00 PM",
    venueLine: "RANCH BOWL ENTERTAINMENT CENTER",
    addressLine: "1600 S. 72nd ST • OMAHA, NE • (402) 393-0900",
    noteLine: "Advance Tickets $2.00  Day of Show $4.00",
    tinyLineOne: "TICKETS AVAILABLE AT THE RANCH BOWL AND ALL TICKETMASTER TICKET OUTLETS",
    tinyLineTwo: "INCLUDING YOUNKERS, HOMER'S AND THE OMAHA CIVIC AUDITORIUM BOX OFFICE",
    tinyLineThree: "RANCH BOWL (402) 393-0900  -  OMAHA, NEBRASKA"
  })
];

window.__ranchBowlShows = ranchBowlShows;

const controls = document.querySelector("#controls");
const fields = [...controls.elements].filter((element) => element.name);
const bg = rfImage();
bg.src=rfAsset("assets/blank-poster.png");
let lastRandomHeadliner = "";
let foldsEnabled = true;
let tapeEnabled = true;
let mounting = 'tape';
let crowdHandsEnabled=true;
const mountChoices = ['tape', 'staples', 'thumbtacks', 'magnets', 'tickets', 'none'];
// Keep each fastening option plausible for its scene's surface.
const wallMountChoices = {
  none: ['tape', 'thumbtacks', 'staples', 'magnets', 'none'],
  brick: ['tape', 'none'],
  'dive-bar': ['tape', 'staples', 'thumbtacks', 'none'],
  'poster-fence': ['tape', 'staples', 'thumbtacks', 'none'],
  wood: ['tape', 'none'],
  crowd: ['held'],
  'light-pole': ['tape', 'thumbtacks', 'staples', 'none'],
  fridge: ['magnets', 'none'],
  frame: ['tickets', 'none']
};
function availableMounts() { return wallMountChoices[document.body.dataset.wall] || mountChoices.filter(choice => !['magnets', 'tickets'].includes(choice)); }
function mountImage(type) {
  if (type === 'thumbtacks') return rfAsset('assets/mounts/steel-thumbtack.png');
  const art =
    '<defs><linearGradient id="m" x2="0" y2="1"><stop stop-color="#fff"/><stop offset=".4" stop-color="#c9ced2"/><stop offset=".65" stop-color="#555e66"/><stop offset="1" stop-color="#eee"/></linearGradient></defs><ellipse cx="12" cy="23" rx="5" ry="4" fill="#30291f"/><ellipse cx="88" cy="23" rx="5" ry="4" fill="#30291f"/><path d="M12 23V12Q12 9 16 9H84Q88 9 88 12V23" fill="none" stroke="#0005" stroke-width="9" transform="translate(1 3)"/><path d="M12 23V12Q12 9 16 9H84Q88 9 88 12V23" fill="none" stroke="url(#m)" stroke-width="7"/><path d="M16 8H83" stroke="#fff" stroke-width="1.5"/>';



  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 34">'+art+'</svg>');
}
function setMount(type) {
  const choices=availableMounts();
  mounting=choices.includes(type)?type:(choices[0]||'none');
  tapeEnabled=mounting==='tape';
  const wrap=document.querySelector('.poster-wrap');
  wrap.dataset.mount=mounting;
  wrap.style.setProperty('--mount-image',['staples','thumbtacks'].includes(mounting)?'url("'+mountImage(mounting)+'")':'none');
  const button=document.querySelector('#tapeCorners');
  const labels={held:'Held',tape:'Tape',staples:'Staples',thumbtacks:'Tacks',magnets:'Magnets',tickets:'Tickets',none:'No mount'};
  button.textContent=mounting==='held'?(crowdHandsEnabled?'Hands on':'Hands off'):labels[mounting];
  button.removeAttribute('aria-pressed');
  button.setAttribute('aria-label','Mount: '+labels[mounting]+'. Next mounting option');
  if(mounting==='held'){button.disabled=false;button.setAttribute('aria-label','Crowd poster: '+(crowdHandsEnabled?'Hands on':'Hands off'));button.setAttribute('aria-pressed',String(crowdHandsEnabled));button.title='Toggle crowd hands on or off';return;}
  button.disabled=choices.length<2;
  button.title=choices.length<2?'No other mount fits this scene':'Cycle '+choices.map(choice=>labels[choice]).join(' → ');
}

document.fonts?.load('400 120px "Anton"').then(updatePreview);

function posterData() {
  const data = {};
  fields.forEach((field) => {
    if (field.type === "radio") {
      if (field.checked) data[field.name] = field.value;
      return;
    }
    data[field.name] = field.value;
  });
  return data;
}

function scaleValue(data, key, fallback = 100) {
  return (Number(data[key] || fallback) || fallback) / 100;
}

function numberValue(data, key, fallback = 0) {
  const value = Number(data[key]);
  return Number.isFinite(value) ? value : fallback;
}

function updatePreview() {
  const data = renderData();
  const poster = document.querySelector("#poster");
  const titleLineCount = [data.headlineOne, data.headlineTwo, data.headlineThree].filter((line) => line.trim()).length;
  poster.dataset.paperColor = data.paperColor || "yellow";
  poster.classList.toggle("single-title", titleLineCount <= 1);
  poster.classList.toggle("two-title", titleLineCount === 2);
  poster.classList.toggle("three-title", titleLineCount >= 3);
  poster.classList.toggle("no-folds", !foldsEnabled);
  const posterWrap = document.querySelector(".poster-wrap");
  posterWrap.classList.toggle("taped", tapeEnabled);
  Object.entries(data).forEach(([key, value]) => {
    const node = document.querySelector(`[data-preview="${key}"]`);
    if (node) node.textContent = value;
  });
  layoutPosterText(data);
}

function layoutPosterText(data) {
  document.querySelector(".poster-copy").style.transform = "none";
  document.querySelectorAll(".ink").forEach(node => { node.style.left = ""; });
  const poster = document.querySelector("#poster");
  const posterHeight = poster.clientHeight;
  const posterWidth = poster.clientWidth;
  const copyMax = 0.84;
  const titleScale = scaleValue(data, "titleScale");
  const lineScales = [scaleValue(data, "lineOneScale"), scaleValue(data, "lineTwoScale"), scaleValue(data, "lineThreeScale")];
  const supportScale = 1;
  const detailScale = 1.18;
  const fineScale = 1.42;
  const titleLineCount = [data.headlineOne, data.headlineTwo, data.headlineThree].filter((line) => line.trim()).length;
  const longTwoLineTitle = isLongTwoLineTitle(data.headlineOne, data.headlineTwo, titleLineCount);
  const lowerStackOffset = titleLineCount === 2 ? 0.018 : titleLineCount >= 3 ? 0.012 : 0;
  const middleLift = titleLineCount <= 1 ? -0.047 : 0;
  const contentLift = longTwoLineTitle ? -0.026 : 0;
  const headlineOne = document.querySelector(".headline-one");
  const headlineTwo = document.querySelector(".headline-two");
  const headlineThree = document.querySelector(".headline-three");
  const topline = document.querySelector(".topline");
  const accent = document.querySelector(".accent");
  const support = document.querySelector(".support");
  const date = document.querySelector(".date");
  const ages = document.querySelector(".ages");
  const left = document.querySelector(".split.left");
  const right = document.querySelector(".split.right");
  const venue = document.querySelector(".venue");
  const address = document.querySelector(".address");
  const note = document.querySelector(".note");
  const tinyOne = document.querySelector(".tiny-one");
  const tinyTwo = document.querySelector(".tiny-two");
  const tinyThree = document.querySelector(".tiny-three");
  [note, tinyOne, tinyTwo, tinyThree].forEach((node) => {
    if (!node) return;
    node.style.display = node.textContent.trim() ? "" : "none";
    node.style.visibility = "";
  });
  const titleBoxTop = posterHeight * 0.072;
  const titleBoxBottom = posterHeight * (titleLineCount === 2 ? 0.392 : 0.35);

  const titleLines = [
    { node: headlineOne, selector: ".headline-one", text: data.headlineOne },
    { node: headlineTwo, selector: ".headline-two", text: data.headlineTwo },
    { node: headlineThree, selector: ".headline-three", text: data.headlineThree }
  ].filter((line) => line.text.trim());

  if (titleLines.length >= 3) {
    titleLines.forEach((line, index) => {
      fitTitleLine(line.node, line.text, titleLines.length, index, titleScale, lineScales[index], index === 0 ? 0.9 : 0.82);
    });
    centerTitleStack(titleLines.map((line) => line.node), poster, posterHeight * 0.086, posterHeight * 0.36, 0.025);
  } else if (titleLines.length === 2) {
    const twoLineGap = twoLineTitleGap(data.headlineOne, data.headlineTwo);
    fitTitleLine(headlineOne, data.headlineOne, titleLines.length, 0, titleScale, lineScales[0], 0.92);
    fitTitleLine(headlineTwo, data.headlineTwo, titleLines.length, 1, titleScale, lineScales[1], 0.86);
    centerTitleStack([headlineOne, headlineTwo], poster, titleBoxTop, titleBoxBottom, twoLineGap);
    if (longTwoLineTitle) {
      shiftTitleStack([headlineOne, headlineTwo], poster, -posterHeight * 0.035);
    }
  } else {
    fitTitleLine(headlineOne, data.headlineOne, titleLines.length, 0, titleScale, lineScales[0], 0.9);
    centerSingleTitle(headlineOne, poster, titleBoxTop, titleBoxBottom);
  }

  const titleTop = (titleLines[0]?.node || headlineOne).getBoundingClientRect().top - poster.getBoundingClientRect().top;
  const topMax = titleTop < posterHeight * 0.06 ? 12 : data.topline.trim().length > 14 ? 17 : 15;
  setTop(topline, Math.max(posterHeight * 0.028, titleTop - posterHeight * 0.035));
  topline.style.fontSize = `${topMax}px`;
  fitLineToBox(".topline", topMax, 8, 0.7);
  // Reserve actual billing height plus a visible gap before the title.
  const billingHeight = topline.getBoundingClientRect().height;
  const billingGap = posterHeight * 0.018;
  const billingMargin = posterHeight * 0.025;
  const billingTop = titleTop - billingHeight - billingGap;
  if (billingTop < billingMargin) {
    shiftTitleStack(titleLines.map((line) => line.node), poster, billingMargin - billingTop);
  }
  setTop(topline, Math.max(billingMargin, billingTop));

  const titleBottom = titleLines.reduce((bottom, line) => Math.max(bottom, bottomOf(line.node, poster)), 0);
  setTop(accent, posterHeight * (0.392 + lowerStackOffset + middleLift + contentLift));
  accent.style.fontSize = `${22 * supportScale}px`;
  fitLine(".accent", 0.55);
  ensureBelow(accent, titleBottom, poster, posterHeight * 0.026);
  setTop(support, posterHeight * (0.435 + lowerStackOffset + middleLift + contentLift));
  support.style.fontSize = `${36 * supportScale}px`;
  setLineBox(support, 0.82);
  fitLineToBox(".support", 36 * supportScale, 24 * supportScale, 0.58);
  ensureBelow(support, bottomOf(accent, poster), poster, posterHeight * 0.012);
  setTop(date, posterHeight * (0.505 + lowerStackOffset + middleLift + contentLift));
  date.style.fontSize = `${23 * detailScale}px`;
  setLineBox(date, copyMax);
  fitLineToBox(".date", 23 * detailScale, 15 * detailScale, 0.65);
  ensureBelow(date, bottomOf(support, poster), poster, posterHeight * 0.015);
  setTop(ages, posterHeight * (0.56 + lowerStackOffset + middleLift + contentLift));
  ages.style.fontSize = `${16 * detailScale}px`;
  fitLine(".ages", 0.6);
  ensureBelow(ages, bottomOf(date, poster), poster, posterHeight * 0.01);
  const splitTop = posterHeight * (0.61 + lowerStackOffset + middleLift + contentLift);
  setTop(left, splitTop);
  setTop(right, splitTop);
  left.style.fontSize = `${13 * detailScale}px`;
  right.style.fontSize = `${13 * detailScale}px`;
  fitLineToBox(".left", 13 * detailScale, 9 * detailScale, 0.68);
  fitLineToBox(".right", 13 * detailScale, 9 * detailScale, 0.68);
  const splitSafeTop = Math.max(
    parseFloat(left.style.top || 0),
    bottomOf(ages, poster) + posterHeight * 0.022
  );
  setTop(left, splitSafeTop);
  setTop(right, splitSafeTop);
  setTop(venue, posterHeight * (0.67 + lowerStackOffset + middleLift + contentLift));
  venue.style.fontSize = `${17 * detailScale}px`;
  setLineBox(venue, copyMax);
  fitLineToBox(".venue", 17 * detailScale, 12 * detailScale, 0.68);
  ensureBelow(venue, Math.max(bottomOf(left, poster), bottomOf(right, poster)), poster, posterHeight * 0.028);
  setTop(address, posterHeight * (0.715 + lowerStackOffset + middleLift + contentLift));
  address.style.fontSize = `${15 * detailScale}px`;
  setLineBox(address, copyMax);
  fitLineToBox(".address", 15 * detailScale, 11 * detailScale, 0.68);
  ensureBelow(address, bottomOf(venue, poster), poster, posterHeight * 0.014);
  layoutFinePrintStack({
    poster,
    minTop: bottomOf(address, poster) + posterHeight * 0.008,
    maxBottom: posterHeight * 0.835,
    note,
    tinyOne,
    tinyTwo,
    tinyThree,
    noteSize: 14 * detailScale,
    tinySize: 10 * fineScale,
    tinyThreeSize: 13 * fineScale
  });
  fitCopyAboveLogos(poster);
}

function isLongTwoLineTitle(first, second, lineCount) {
  if (lineCount !== 2) return false;
  const compact = `${first || ""}${second || ""}`.replace(/\s+/g, "");
  const longest = Math.max(
    (first || "").replace(/\s+/g, "").length,
    (second || "").replace(/\s+/g, "").length
  );
  return compact.length >= 15 || longest >= 10;
}

function shiftTitleStack(nodes, poster, delta) {
  const topLimit = poster.clientHeight * 0.045;
  const currentTop = Math.min(...nodes.map((node) => node.getBoundingClientRect().top - poster.getBoundingClientRect().top));
  const allowedDelta = Math.max(delta, topLimit - currentTop);
  nodes.forEach((node) => {
    setTop(node, parseFloat(node.style.top || 0) + allowedDelta);
    centerNodeByRenderedBox(node, poster);
  });
}

function setTop(node, value) {
  if (node) node.style.top = `${value}px`;
}

function setLineWidth(node, width) {
  if (!node) return;
  node.style.width = `${width}px`;
  const parentWidth = node.parentElement?.clientWidth || width;
  node.style.left = `${Math.max(0, (parentWidth - width) / 2)}px`;
}

function setLineBox(node, widthRatio) {
  if (!node) return;
  node.style.left = `${((1 - widthRatio) / 2) * 100}%`;
  node.style.width = `${widthRatio * 100}%`;
}

function centerSingleTitle(node, poster, boxTop, boxBottom) {
  const rect = node.getBoundingClientRect();
  const posterRect = poster.getBoundingClientRect();
  const currentTop = rect.top - posterRect.top;
  const targetTop = boxTop + (boxBottom - boxTop - rect.height) / 2;
  setTop(node, parseFloat(node.style.top || 0) + targetTop - currentTop);
  centerNodeByRenderedBox(node, poster);
}

function centerTwoLineTitle(first, second, poster, boxTop, boxBottom) {
  const posterRect = poster.getBoundingClientRect();
  const firstRect = first.getBoundingClientRect();
  const secondRect = second.getBoundingClientRect();
  const gap = -firstRect.height * 0.08;
  const totalHeight = firstRect.height + gap + secondRect.height;
  const top = boxTop + (boxBottom - boxTop - totalHeight) / 2 + poster.clientHeight * 0.01;
  setTop(first, parseFloat(first.style.top || 0) + top - (firstRect.top - posterRect.top));
  setTop(second, parseFloat(second.style.top || 0) + top + firstRect.height + gap - (secondRect.top - posterRect.top));
  centerNodeByRenderedBox(first, poster);
  centerNodeByRenderedBox(second, poster);
}

function centerTitleStack(nodes, poster, boxTop, boxBottom, gapRatio) {
  const posterRect = poster.getBoundingClientRect();
  let rects = nodes.map((node) => node.getBoundingClientRect());
  const averageHeight = rects.reduce((sum, rect) => sum + rect.height, 0) / Math.max(nodes.length, 1);
  const gap = averageHeight * gapRatio;
  let totalHeight = rects.reduce((sum, rect) => sum + rect.height, 0) + gap * Math.max(nodes.length - 1, 0);
  const availableHeight = boxBottom - boxTop;

  if (totalHeight > availableHeight) {
    const shrink = Math.max(0.68, (availableHeight / totalHeight) * 0.985);
    nodes.forEach((node) => {
      const currentSize = parseFloat(node.style.fontSize || getComputedStyle(node).fontSize || 0);
      if (currentSize) node.style.fontSize = `${currentSize * shrink}px`;
    });
    rects = nodes.map((node) => node.getBoundingClientRect());
    const adjustedAverageHeight = rects.reduce((sum, rect) => sum + rect.height, 0) / Math.max(nodes.length, 1);
    const adjustedGap = adjustedAverageHeight * gapRatio;
    totalHeight = rects.reduce((sum, rect) => sum + rect.height, 0) + adjustedGap * Math.max(nodes.length - 1, 0);
    return centerTitleStack(nodes, poster, boxTop, boxBottom, gapRatio);
  }

  let top = boxTop + (boxBottom - boxTop - totalHeight) / 2 + poster.clientHeight * 0.008;

  nodes.forEach((node, index) => {
    const currentTop = rects[index].top - posterRect.top;
    setTop(node, parseFloat(node.style.top || 0) + top - currentTop);
    top += rects[index].height + gap;
    centerNodeByRenderedBox(node, poster);
  });
}

function twoLineTitleGap(first, second) {
  const longest = Math.max(
    (first || "").replace(/\s+/g, "").length,
    (second || "").replace(/\s+/g, "").length
  );
  if (longest >= 10) return 0.08;
  if (longest >= 7) return 0.018;
  return 0.035;
}

function centerNodeByRenderedBox(node, poster) {
  const posterRect = poster.getBoundingClientRect();
  const rect = node.getBoundingClientRect();
  const currentCenter = rect.left - posterRect.left + rect.width / 2;
  const targetCenter = poster.clientWidth / 2;
  const currentLeft = parseFloat(node.style.left || getComputedStyle(node).left || 0);
  node.style.left = `${currentLeft + targetCenter - currentCenter}px`;
}

function bottomOf(node, poster) {
  if (!node) return 0;
  return node.getBoundingClientRect().bottom - poster.getBoundingClientRect().top;
}

function ensureBelow(node, previousBottom, poster, gap) {
  if (!node) return;
  const posterRect = poster.getBoundingClientRect();
  const rect = node.getBoundingClientRect();
  const currentTop = rect.top - posterRect.top;
  const safeTop = previousBottom + gap;
  if (currentTop < safeTop) {
    setTop(node, parseFloat(node.style.top || 0) + safeTop - currentTop);
  }
}

function layoutFinePrintStack({ poster, minTop, maxBottom, note, tinyOne, tinyTwo, tinyThree, noteSize, tinySize, tinyThreeSize }) {
  const nodes = [note, tinyOne, tinyTwo, tinyThree].filter(Boolean);
  nodes.forEach((node) => {
    node.dataset.scaleX = "1";
    node.style.transform = "";
    node.style.fontSize = "";
    node.style.lineHeight = "0.95";
    const span = node.querySelector(":scope > .fine-text");
    if (span) span.style.transform = "";
    if (node.textContent.trim()) node.style.display = "";
  });

  nodes.forEach((node) => setLineBox(node, 0.92));

  fitFixedLineToBox(".note", noteSize, 0.44);
  fitFixedLineToBox(".tiny-one", tinySize, 0.42);
  fitFixedLineToBox(".tiny-two", tinySize, 0.42);
  fitFixedLineToBox(".tiny-three", tinyThreeSize, 0.52);

  const activeNodes = () => nodes.filter((node) => node.textContent.trim() && node.style.display !== "none");
  const fits = () => measureStack(activeNodes(), poster).total <= Math.max(1, maxBottom - minTop);

  setFinePrintLineHeight(activeNodes(), "0.95");
  if (!fits()) setFinePrintLineHeight(activeNodes(), "0.82");
  fitFinePrintVertically(activeNodes(), poster, Math.max(1, maxBottom - minTop));

  expandFinePrintToBand(activeNodes(), poster, Math.max(1, maxBottom - minTop));
  placeFinePrintStack(activeNodes(), poster, minTop, maxBottom);
  activeNodes().forEach((node) => {
    centerFinePrintSpan(node, poster);
    clampFinePrintToPoster(node, poster);
    centerFinePrintSpan(node, poster);
  });
}

function fitFinePrintVertically(nodes, poster, availableHeight) {
  for (let attempt = 0; attempt < 6; attempt += 1) {
    const total = measureStack(nodes, poster).total;
    if (total <= availableHeight) return;
    const shrink = Math.max(0.82, (availableHeight / Math.max(total, 1)) * 0.96);
    nodes.forEach((node) => {
      const currentSize = parseFloat(node.style.fontSize || getComputedStyle(node).fontSize || 0);
      const minSize = finePrintMinSize(node);
      if (currentSize) node.style.fontSize = `${Math.max(minSize, currentSize * shrink)}px`;
    });
    fitFixedLineToBox(".note", parseFloat(document.querySelector(".note")?.style.fontSize || 0) || 1, 0.42);
    fitFixedLineToBox(".tiny-one", parseFloat(document.querySelector(".tiny-one")?.style.fontSize || 0) || 1, 0.4);
    fitFixedLineToBox(".tiny-two", parseFloat(document.querySelector(".tiny-two")?.style.fontSize || 0) || 1, 0.4);
    fitFixedLineToBox(".tiny-three", parseFloat(document.querySelector(".tiny-three")?.style.fontSize || 0) || 1, 0.5);
  }
}

function measureStack(activeNodes, poster) {
  const gap = poster.clientHeight * 0.0035;
  if (!activeNodes.length) return { gap, total: 0 };
  const total = activeNodes.reduce((sum, node) => sum + node.getBoundingClientRect().height, 0) + gap * Math.max(activeNodes.length - 1, 0);
  return { gap, total };
}

function setFinePrintLineHeight(nodes, lineHeight) {
  nodes.forEach((node) => {
    node.style.lineHeight = lineHeight;
  });
}

function placeFinePrintStack(activeNodes, poster, minTop, maxBottom) {
  if (!activeNodes.length) return;
  const { gap } = measureStack(activeNodes, poster);
  const total = measureStack(activeNodes, poster).total;
  let top = minTop + Math.max(0, (maxBottom - minTop - total) * 0.46);
  activeNodes.forEach((node) => {
    setTop(node, top);
    top += node.getBoundingClientRect().height + gap;
  });
}

function expandFinePrintToBand(activeNodes, poster, availableHeight) {
  if (!activeNodes.length) return;
  const maxAttempts = 5;
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const total = measureStack(activeNodes, poster).total;
    if (total >= availableHeight * 0.9) return;
    activeNodes.forEach((node) => {
      const currentSize = parseFloat(node.style.fontSize || getComputedStyle(node).fontSize || 0);
      const maxSize = node.classList.contains("tiny-three") ? 19 : node.classList.contains("note") ? 17 : 15;
      if (currentSize) node.style.fontSize = `${Math.min(maxSize, currentSize * 1.12)}px`;
    });
    fitFixedLineToBox(".note", parseFloat(document.querySelector(".note")?.style.fontSize || 0) || 1, 0.42);
    fitFixedLineToBox(".tiny-one", parseFloat(document.querySelector(".tiny-one")?.style.fontSize || 0) || 1, 0.4);
    fitFixedLineToBox(".tiny-two", parseFloat(document.querySelector(".tiny-two")?.style.fontSize || 0) || 1, 0.4);
    fitFixedLineToBox(".tiny-three", parseFloat(document.querySelector(".tiny-three")?.style.fontSize || 0) || 1, 0.5);
    if (measureStack(activeNodes, poster).total > availableHeight) {
      fitFinePrintVertically(activeNodes, poster, availableHeight);
      return;
    }
  }
}

function finePrintMinSize(node) {
  if (node.classList.contains("tiny-three")) return 12;
  if (node.classList.contains("note")) return 10.5;
  return 9.5;
}

function fitHeadline(selector, options) {
  const node = document.querySelector(selector);
  if (!node) return;
  node.style.left = "";
  const posterWidth = node.parentElement.clientWidth;
  const compactText = (node.textContent || "").replace(/\s+/g, "");
  const target = options.longTarget && compactText.length > 5 ? options.longTarget : options.target;
  const targetWidth = posterWidth * target;
  const maxSize = posterWidth * options.maxCqw / 100;
  const minSize = posterWidth * options.minCqw / 100;
  let size = maxSize;

  const scaleY = options.scaleY ?? 1;
  node.style.transform = `rotate(-0.25deg) scaleX(1) scaleY(${scaleY})`;
  node.style.fontSize = `${size}px`;

  while (measureTextNode(node) > targetWidth && size > minSize) {
    size -= 2;
    node.style.fontSize = `${size}px`;
  }

  const squeeze = targetWidth / Math.max(measureTextNode(node), 1);
  const maxScaleX = options.fillWidth ? options.maxScaleX ?? 1 : 1;
  const naturalScale = options.allowNatural && squeeze > 1 ? 1 : squeeze;
  const scale = Math.min(maxScaleX, Math.max(options.minScaleX ?? 0.82, naturalScale));
  node.style.transform = `rotate(-0.25deg) scaleX(${scale}) scaleY(${scaleY})`;
}

function fitTitleLine(node, text, lineCount, lineIndex, titleScale, lineScale, targetRatio) {
  if (!node) return;
  const posterWidth = node.parentElement.clientWidth;
  const compactLength = (text || "").replace(/\s+/g, "").length;
  const maxWidth = posterWidth * Math.max(0.48, Math.min(0.94, targetRatio * lineScale));
  const singleShortTitle = lineCount <= 1 && compactLength <= 6;
  const maxHeight = node.parentElement.clientHeight * (lineCount >= 3 ? 0.125 : lineCount === 2 ? 0.19 : singleShortTitle ? 0.31 : 0.24) * lineScale;
  const candidates = titleFontCandidates(text, lineCount);
  let best = null;

  candidates.forEach((candidate) => {
    node.style.left = "";
    node.style.fontFamily = candidate.family;
    node.style.fontWeight = candidate.weight;
    node.style.transform = `rotate(-0.25deg) scaleX(1) scaleY(${candidate.scaleY})`;
    let size = posterWidth * candidate.maxCqw / 100 * titleScale * lineScale;
    const minSize = posterWidth * 6 / 100;
    node.style.fontSize = `${size}px`;

    while ((measureTextNode(node) > maxWidth || size * candidate.scaleY > maxHeight) && size > minSize) {
      size -= 2;
      node.style.fontSize = `${size}px`;
    }

    const naturalWidth = Math.max(measureTextNode(node), 1);
    const fillScale = maxWidth / naturalWidth;
    const scaleX = Math.max(0.44, Math.min(candidate.maxScaleX, fillScale));
    const widthScore = Math.min(maxWidth, naturalWidth * scaleX) / maxWidth;
    const heightScore = Math.min(maxHeight, size * candidate.scaleY) / maxHeight;
    const score = widthScore * 0.62 + heightScore * 0.38 - Math.max(0, 0.58 - scaleX) * 0.45;

    if (!best || score > best.score) {
      best = { candidate, size, scaleX, score };
    }
  });

  // Sizes above 100% make long names that already fill the width taller instead of wider.
  const stretchY = lineScale > 1 ? Math.max(1, Math.min(lineScale, maxHeight / Math.max(best.size * best.candidate.scaleY, 1))) : 1;
  node.style.left = "";
  node.style.fontFamily = best.candidate.family;
  node.style.fontWeight = best.candidate.weight;
  node.style.fontSize = `${best.size}px`;
  node.style.transform = `rotate(-0.25deg) scaleX(${best.scaleX}) scaleY(${best.candidate.scaleY * stretchY})`;
}

function titleFontCandidates(text, lineCount) {
  const trimmed = (text || "").trim();
  const compactLength = trimmed.replace(/\s+/g, "").length;
  const isSingleWord = !/\s/.test(trimmed);
  const block = {
    family: '"Arial Black", Impact, sans-serif',
    exportFamily: "Arial Black, Impact, sans-serif",
    weight: "900",
    scaleY: lineCount >= 3 ? 1.02 : 1.14,
    maxCqw: lineCount >= 3 ? 20 : lineCount === 2 ? 30 : 36,
    maxScaleX: 1.14
  };
  const tall = {
    family: '"Anton", Impact, "Arial Black", sans-serif',
    exportFamily: "Anton, Impact, Arial Black, sans-serif",
    weight: "400",
    scaleY: lineCount >= 3 ? 1.18 : lineCount === 2 ? 1.1 : 1.22,
    maxCqw: lineCount >= 3 ? 22 : lineCount === 2 ? 32 : 40,
    maxScaleX: isSingleWord && compactLength <= 6 ? 1.62 : isSingleWord && compactLength <= 8 ? 1.38 : 1.12
  };
  if (isSingleWord && compactLength <= 6) return [tall];
  return isSingleWord ? [tall, block] : [block, tall];
}

function measureTextNode(node) {
  const clone = measureTextNode.element || (measureTextNode.element = document.createElement('span'));
  clone.textContent = node.textContent;
  const computed = getComputedStyle(node);
  clone.style.position = "fixed";
  clone.style.left = "-9999px";
  clone.style.top = "-9999px";
  clone.style.width = "max-content";
  clone.style.transform = "none";
  clone.style.visibility = "hidden";
  clone.style.whiteSpace = "nowrap";
  clone.style.fontFamily = computed.fontFamily;
  clone.style.fontSize = computed.fontSize;
  clone.style.fontStretch = computed.fontStretch;
  clone.style.fontStyle = computed.fontStyle;
  clone.style.fontWeight = computed.fontWeight;
  clone.style.letterSpacing = computed.letterSpacing;
  clone.style.lineHeight = computed.lineHeight;
  clone.style.textTransform = computed.textTransform;
  document.body.appendChild(clone);
  const width = clone.getBoundingClientRect().width;
  clone.textContent = "";
  return width;
}

function fitLine(selector, minimum = 0.72) {
  const node = document.querySelector(selector);
  if (!node) return;
  node.style.transform = "rotate(-0.25deg) scaleX(1)";
  const ratio = node.clientWidth / Math.max(measureTextNode(node), 1);
  node.style.transform = `rotate(-0.25deg) scaleX(${Math.min(1, Math.max(minimum, ratio))})`;
}

function fitLineToBox(selector, maxSize, minSize, minimumScale = 0.72) {
  const node = document.querySelector(selector);
  if (!node) return;
  let size = maxSize;
  node.style.transform = "rotate(-0.25deg) scaleX(1)";
  node.style.fontSize = `${size}px`;
  while (measureTextNode(node) > node.clientWidth && size > minSize) {
    size -= 1;
    node.style.fontSize = `${size}px`;
  }
  node.style.transform = "rotate(-0.25deg) scaleX(1)";
  const ratio = node.clientWidth / Math.max(measureTextNode(node), 1);
  const scale = Math.min(1, Math.max(minimumScale, ratio));
  if (scale < 1 && ratio < minimumScale) {
    while (measureTextNode(node) * minimumScale > node.clientWidth && size > minSize * 0.75) {
      size -= 1;
      node.style.fontSize = `${size}px`;
    }
  }
  const finalRatio = node.clientWidth / Math.max(measureTextNode(node), 1);
  node.style.transform = `rotate(-0.25deg) scaleX(${Math.min(1, finalRatio)})`;
}

function fitFixedLineToBox(selector, size, minimumScale = 0.18) {
  const node = document.querySelector(selector);
  if (!node) return;
  const span = ensureFineTextSpan(node);
  const targetWidth = node.clientWidth * 0.98;
  let fontSize = size;
  if (!node.style.lineHeight) node.style.lineHeight = "0.95";
  node.style.fontSize = `${fontSize}px`;
  node.style.transform = "rotate(-0.25deg)";
  node.style.left = "";
  span.style.transform = "scaleX(1)";
  const minFontSize = finePrintMinSize(node);
  const minFitSize = Math.max(minFontSize, size * 0.72);
  while (measureTextNode(span) > targetWidth && fontSize > minFitSize) {
    fontSize -= 1;
    if (fontSize < minFitSize) fontSize = minFitSize;
    node.style.fontSize = `${fontSize}px`;
  }
  const ratio = targetWidth / Math.max(measureTextNode(span), 1);
  const maxStretch = node.classList.contains("tiny") ? 1.22 : 1.08;
  const scale = Math.min(maxStretch, ratio >= minimumScale ? ratio : ratio * 0.985);
  node.dataset.scaleX = String(scale);
  span.style.transform = `scaleX(${scale})`;
}

function ensureFineTextSpan(node) {
  let span = node.querySelector(":scope > .fine-text");
  if (span) return span;
  const text = node.textContent;
  node.textContent = "";
  span = document.createElement("span");
  span.className = "fine-text";
  span.textContent = text;
  node.append(span);
  return span;
}

function clampFinePrintToPoster(node, poster) {
  const posterRect = poster.getBoundingClientRect();
  const target = node.querySelector(":scope > .fine-text") || node;
  let rect = target.getBoundingClientRect();
  let scale = Number(node.dataset.scaleX || 1) || 1;
  const sideMargin = posterRect.width * 0.045;
  const safeLeft = posterRect.left + sideMargin;
  const safeRight = posterRect.right - sideMargin;
  for (let attempt = 0; attempt < 6 && (rect.left < safeLeft || rect.right > safeRight); attempt += 1) {
    const allowedWidth = posterRect.width * 0.91;
    scale *= Math.max(0.08, Math.min(0.98, allowedWidth / Math.max(rect.width, 1)));
    node.dataset.scaleX = String(scale);
    target.style.transform = `scaleX(${scale})`;
    rect = target.getBoundingClientRect();
  }
}

function centerFinePrintSpan(node, poster) {
  const target = node.querySelector(":scope > .fine-text") || node;
  const posterRect = poster.getBoundingClientRect();
  const rect = target.getBoundingClientRect();
  const posterCenter = posterRect.left + posterRect.width / 2;
  const textCenter = rect.left + rect.width / 2;
  const currentLeft = parseFloat(node.style.left || getComputedStyle(node).left || 0);
  node.style.left = `${currentLeft + posterCenter - textCenter}px`;
}

function applyValues(values) {
  const merged = {
    titleScale: defaults.titleScale,
    lineOneScale: defaults.lineOneScale,
    lineTwoScale: defaults.lineTwoScale,
    lineThreeScale: defaults.lineThreeScale,
    ...values
  };
  fields.forEach((field) => {
    if (field.type === "radio") {
      field.checked = (merged[field.name] ?? defaults[field.name] ?? "yellow") === field.value;
      return;
    }
    field.value = merged[field.name] ?? field.defaultValue ?? "";
  });
  updatePreview();
}

function drawFittedText(ctx, text, x, y, width, size, options = {}) {
  const family = options.family ?? "Arial Black, Arial, Helvetica, sans-serif";
  const weight = options.weight ?? "900";
  const style = options.style ? `${options.style} ` : "";
  let fontSize = size;
  let usedSize = size;
  ctx.textAlign = options.align ?? "center";
  ctx.textBaseline = "alphabetic";
  ctx.fillStyle = "rgba(2, 2, 2, 0.94)";

  do {
    usedSize = fontSize;
    ctx.font = `${style}${weight} ${fontSize}px ${family}`;
    fontSize -= 2;
  } while (ctx.measureText(text).width > width && fontSize > size * (options.minScale ?? 0.55));

  ctx.save();
  ctx.translate(x, y);
  ctx.rotate((options.rotate ?? -0.25) * Math.PI / 180);
  const upperText = text.toUpperCase();
  const measured = Math.max(ctx.measureText(upperText).width, 1);
  const scaleX = options.fillWidth ? width / measured : Math.min(1, width / measured);
  ctx.scale(scaleX, options.scaleY ?? 1);
  ctx.shadowColor = "transparent";
  ctx.shadowOffsetX = 0;
  ctx.shadowOffsetY = 0;
  ctx.shadowBlur = 0;
  ctx.fillText(upperText, 0, 0);
  ctx.restore();

  const scaleY = options.scaleY ?? 1;
  return {
    top: y - usedSize * 0.82 * scaleY,
    bottom: y + usedSize * 0.18 * scaleY,
    height: usedSize * scaleY
  };
}

function measureFittedText(ctx, text, x, y, width, size, options = {}) {
  const family = options.family ?? "Arial Black, Arial, Helvetica, sans-serif";
  const weight = options.weight ?? "900";
  const style = options.style ? `${options.style} ` : "";
  let fontSize = size;
  let usedSize = size;

  do {
    usedSize = fontSize;
    ctx.font = `${style}${weight} ${fontSize}px ${family}`;
    fontSize -= 2;
  } while (ctx.measureText(text).width > width && fontSize > size * (options.minScale ?? 0.55));

  const scaleY = options.scaleY ?? 1;
  return {
    top: y - usedSize * 0.82 * scaleY,
    bottom: y + usedSize * 0.18 * scaleY,
    height: usedSize * scaleY
  };
}

function addInkWear(ctx, width, height) {
  const image = ctx.getImageData(0, 0, width, height);
  const data = image.data;
  for (let i = 0; i < data.length; i += 4) {
    const isInk = data[i] < 22 && data[i + 1] < 22 && data[i + 2] < 22 && data[i + 3] > 120;
    if (isInk && Math.random() > 0.985) {
      data[i + 3] = Math.max(0, data[i + 3] - 150);
    }
  }
  ctx.putImageData(image, 0, 0);
}

const paperColors = {
  yellow: { color: "#d2d610", alpha: 0.18 },
  green: { color: "#00b968", alpha: 0.72 },
  pink: { color: "#f06aa1", alpha: 0.72 },
  red: { color: "#e14835", alpha: 0.72 },
  orange: { color: "#f47b4f", alpha: 0.72 },
  blue: { color: "#75c4d7", alpha: 0.72 }
};

function tintExportPaper(ctx, width, height, paperColor) {
  tintExportPaperRegion(ctx, 0, 0, width, height, paperColor);
}

function tintExportPaperRegion(ctx, x, y, width, height, paperColor) {
  const tint = paperColors[paperColor] || paperColors.yellow;
  if (!tint) return;
  ctx.save();
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.globalCompositeOperation = "color";
  ctx.globalAlpha = tint.alpha;
  ctx.fillStyle = tint.color;
  ctx.fillRect(x, y, width, height);
  ctx.restore();
}

async function exportPoster() {
  await document.fonts?.ready;
  await waitForImage(bg);
  if (window.html2canvas) {
    try {
      await exportPosterScreenshot();
      return;
    } catch (error) { console.warn("Using alternate PNG renderer", error); }
  }
  await exportPosterCanvasFallback();
}

async function exportPosterScreenshot() {
  const target = document.querySelector(".poster-wrap");
  const poster = document.querySelector("#poster");
  if (!target || !poster) throw new Error("Flyer preview is missing.");
  const data = renderData();
  document.body.classList.add("exporting-png");
  await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  const crop = exportCropRect(target);
  const posterRect = poster.getBoundingClientRect();
  // Torn tape is drawn onto the PNG separately so its ragged shape keeps the on-screen size and angle.
  const tapePieces = (tapeEnabled || mounting === 'magnets' || mounting === 'tickets') ? await tornTapePieces() : [];
  // If tape or magnets hang past the left edge of the page, nudge the poster right in the snapshot only.
  const shiftX = Math.max(0, Math.ceil(-(crop.left + window.scrollX)));
  crop.left += shiftX;
  if (tapePieces.length) document.body.classList.add("exporting-tape");
  let canvas;
  try {
    canvas = await window.html2canvas(document.body, {
      backgroundColor: null,
      scale: Number(document.querySelector("#exportSize").value) / crop.width,
      useCORS: true,
      allowTaint: false,
      logging: false,
      x: crop.left + window.scrollX,
      y: crop.top + window.scrollY,
      width: crop.width,
      height: crop.height,
      scrollX: window.scrollX,
      scrollY: window.scrollY,
      onclone: (clonedDocument) => {
        if (document.body.dataset.wall === 'none') {
          clonedDocument.body.style.setProperty('background', 'transparent', 'important');
          clonedDocument.documentElement.style.setProperty('background', 'transparent', 'important');
        }
        const panel = clonedDocument.querySelector(".panel");
        if (panel) panel.style.visibility = "hidden";
        const stage = clonedDocument.querySelector(".stage");
        if (stage && shiftX) stage.style.transform = `translateX(${shiftX}px)`;
        const roomDark = clonedDocument.querySelector(".room-dark");
        if (roomDark && shiftX) roomDark.style.transform = `translateX(${shiftX}px)`;
      }
    });
  } finally {
    document.body.classList.remove("exporting-png");
    document.body.classList.remove("exporting-tape");
  }
  const ctx = canvas.getContext("2d");
  if (ctx) {
    const scaleX = canvas.width / crop.width;
    const scaleY = canvas.height / crop.height;
    tintExportPaperRegion(
      ctx,
      (posterRect.left + shiftX - crop.left) * scaleX,
      (posterRect.top - crop.top) * scaleY,
      posterRect.width * scaleX,
      posterRect.height * scaleY,
      data.paperColor
    );
    tapePieces.forEach((piece) => {
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.translate((piece.cx + shiftX - crop.left) * scaleX, (piece.cy - crop.top) * scaleY);
      ctx.rotate(piece.angle);
      ctx.globalAlpha = piece.opacity;
      ctx.drawImage(piece.image, -piece.width * scaleX / 2, -piece.height * scaleY / 2, piece.width * scaleX, piece.height * scaleY);
      ctx.restore();
    });
  }
  await downloadCanvas(canvas, data);
}

async function tornTapePieces() {
  const pieces = [];
  for (const node of document.querySelectorAll('.poster-wrap.taped .tape, .poster-wrap[data-mount="magnets"] .tape, .poster-wrap[data-mount="tickets"] .tape')) {
    const style = getComputedStyle(node);
    const url = (style.backgroundImage.match(/url\(["']?(.*?)["']?\)$/) || [])[1];
    if (!node.offsetWidth) continue;
    let image;
    if (url) {
      image = rfImage();
      image.src=rfAsset(url);
      try { await image.decode(); } catch { continue; }
    } else if (mounting === 'tape' && document.body.dataset.wall !== 'wood') {
      // Redraw solid masking tape after the paper tint, so neither the poster
      // nor the scene can show through or recolor the overlapping strip.
      image = document.createElement('canvas');
      image.width = 768;
      image.height = Math.max(1, Math.round(768 * node.offsetHeight / node.offsetWidth));
      const tapeContext = image.getContext('2d');
      const edge = [[2,10],[7,6],[94,7],[98,13],[96,87],[92,94],[5,92],[2,86]];
      tapeContext.beginPath();
      edge.forEach(([x,y],index) => tapeContext[index ? 'lineTo' : 'moveTo'](x * image.width / 100, y * image.height / 100));
      tapeContext.closePath();
      const paper = tapeContext.createLinearGradient(0,0,0,image.height);
      paper.addColorStop(0,'#dfd0a4');
      paper.addColorStop(.5,'#d4c294');
      paper.addColorStop(1,'#cbbc8e');
      tapeContext.fillStyle = paper;
      tapeContext.fill();
    } else continue;
    const rect = node.getBoundingClientRect();
    const matrix = new DOMMatrixReadOnly(style.transform === "none" ? undefined : style.transform);
    pieces.push({
      image,
      cx: rect.left + rect.width / 2,
      cy: rect.top + rect.height / 2,
      width: node.offsetWidth,
      height: node.offsetHeight,
      angle: Math.atan2(matrix.b, matrix.a),
      opacity: Number(style.opacity) || 1
    });
  }
  return pieces;
}

function exportCropRect(target) {
  const rects = [target.getBoundingClientRect()];
  if (tapeEnabled || mounting === 'magnets' || mounting === 'tickets') {
    document.querySelectorAll(".tape").forEach((node) => {
      const rect = node.getBoundingClientRect();
      if (rect.width && rect.height) rects.push(rect);
    });
  }
  if (document.body.dataset.wall === "frame") {
    const frame = document.querySelector(".frame-art")?.getBoundingClientRect();
    if (frame && frame.width) rects.push(frame);
    const lightSwitch = document.querySelector(".wall-switch")?.getBoundingClientRect();
    if (lightSwitch && lightSwitch.width) rects.push(lightSwitch);
    const lamp = document.querySelector(".picture-light")?.getBoundingClientRect();
    if (lamp && lamp.width) rects.push(lamp);
  }
  const left = Math.min(...rects.map((rect) => rect.left));
  const top = Math.min(...rects.map((rect) => rect.top));
  const right = Math.max(...rects.map((rect) => rect.right));
  const bottom = Math.max(...rects.map((rect) => rect.bottom));
  const pad = document.body.dataset.wall === 'frame' ? target.getBoundingClientRect().width * 0.07 : (tapeEnabled || mounting === 'magnets' || mounting === 'tickets') ? Math.max(6, target.getBoundingClientRect().width * 0.025) : 0;
  // Nothing renders above the page, so start no higher than its top edge.
  const cropTop = Math.max(top - pad, -window.scrollY);
  return {
    left: Math.floor(left - pad),
    top: Math.floor(cropTop),
    width: Math.ceil(right - left + pad * 2),
    height: Math.ceil(bottom + pad - cropTop)
  };
}

async function exportPosterCanvasFallback() {
  const baseCanvas = document.querySelector("#exportCanvas");
  if (!baseCanvas) throw new Error("Export canvas is missing.");
  const pad = tapeEnabled ? 120 : 0;
  const canvas = tapeEnabled ? document.createElement("canvas") : baseCanvas;
  canvas.width = baseCanvas.width + pad * 2;
  canvas.height = baseCanvas.height + pad * 2;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Canvas export is not supported in this browser.");
  const data = renderData();
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.save();
  ctx.translate(pad, pad);
  ctx.save();
  ctx.beginPath();
  ctx.rect(0, 0, baseCanvas.width, baseCanvas.height);
  ctx.clip();
  ctx.drawImage(bg, 0, 0, baseCanvas.width, baseCanvas.height);
  ctx.restore();

  tintExportPaper(ctx, baseCanvas.width, baseCanvas.height, data.paperColor);
  ctx.save();
  ctx.scale(1, 0.88);
  drawExportLayout(ctx, data, baseCanvas.width, baseCanvas.height);
  ctx.restore();
  if (foldsEnabled) drawFoldLines(ctx, baseCanvas.width, baseCanvas.height);
  ctx.restore();
  if (tapeEnabled) drawTapeCorners(ctx, baseCanvas.width, baseCanvas.height, pad, pad);
  if (mounting==='staples'||mounting==='thumbtacks') {
    const hardware=rfImage(); hardware.src=rfAsset(mountImage(mounting)); await hardware.decode();
    const w=baseCanvas.width*(mounting==='staples'?.058:.04),h=w*(mounting==='staples'?.34:1);
    for(const x of [.04,.96]) for(const y of [.025,.975]) ctx.drawImage(hardware,pad+baseCanvas.width*x-(x>.5?w:0),pad+baseCanvas.height*y-(y>.5?h:0),w,h);
  }

  await downloadCanvas(canvas, data);
}

async function downloadCanvas(canvas, data) {
  const width = Number(document.querySelector('#exportSize').value);
  const output = document.createElement('canvas');
  output.width = width;
  output.height = Math.round(width * 17 / 11);
  const outputContext = output.getContext('2d');
  const fit = Math.min(output.width / canvas.width, output.height / canvas.height);
  outputContext.drawImage(canvas, (output.width-canvas.width*fit)/2, (output.height-canvas.height*fit)/2, canvas.width*fit, canvas.height*fit);
  canvas = output;
  const link = document.createElement("a");
  const slug = (data.headlineOne || "custom").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
  link.download = `${slug || "custom"}-ranch-bowl-flyer.png`;
  link.href = await canvasDownloadUrl(canvas);
  document.body.appendChild(link);
  link.click();
  link.remove();
  if (link.href.startsWith("blob:")) {
    setTimeout(() => URL.revokeObjectURL(link.href), 1000);
  }
}

function waitForImage(image) {
  if (image.complete) return image.naturalWidth > 0 ? Promise.resolve() : Promise.reject(new Error("Poster background image failed to load."));
  return new Promise((resolve, reject) => {
    image.addEventListener("load", resolve, { once: true });
    image.addEventListener("error", () => reject(new Error("Poster background image failed to load.")), { once: true });
  });
}

async function canvasDownloadUrl(canvas) {
  try {
    const blob = await canvasToBlob(canvas);
    return URL.createObjectURL(blob);
  } catch (error) {
    return canvas.toDataURL("image/png");
  }
}

function canvasToBlob(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error("Could not create PNG file."));
    }, "image/png");
  });
}

function drawExportLayout(ctx, data, width, height) {
  const cx = width / 2;
  const copyWidth = width * 0.84;
  const titleScale = scaleValue(data, "titleScale");
  const lineScales = [scaleValue(data, "lineOneScale"), scaleValue(data, "lineTwoScale"), scaleValue(data, "lineThreeScale")];
  const supportScale = 1;
  const detailScale = 1.18;
  const fineScale = 1.42;
  const titleLineCount = [data.headlineOne, data.headlineTwo, data.headlineThree].filter((line) => line.trim()).length;
  const hasThreeTitleLines = titleLineCount >= 3;
  const longTwoLineTitle = isLongTwoLineTitle(data.headlineOne, data.headlineTwo, titleLineCount);
  const lowerStackOffset = titleLineCount === 2 ? 0.018 : titleLineCount >= 3 ? 0.012 : 0;
  const middleLift = titleLineCount <= 1 ? -0.047 : 0;
  const contentLift = longTwoLineTitle ? -0.026 : 0;

  drawFittedText(ctx, data.topline, cx, height * 0.054, width * 0.56, 22, {
    family: "Arial Black, Arial, sans-serif",
    minScale: 0.55
  });

  let titleBottom;
  const exportTitleLines = [data.headlineOne, data.headlineTwo, data.headlineThree].filter((line) => line.trim());
  if (exportTitleLines.length >= 3) {
    const size = 158 * titleScale;
    const shapes = exportTitleLines.slice(0, 3).map((line) => titleLineSettings(line, exportTitleLines.length));
    const lineSizes = exportTitleLines.slice(0, 3).map((_, index) => size * lineScales[index]);
    const lineHeights = lineSizes.map((lineSize, index) => lineSize * shapes[index].scaleY);
    const averageLineHeight = lineHeights.reduce((sum, lineHeight) => sum + lineHeight, 0) / lineHeights.length;
    const gap = -averageLineHeight * 0.04;
    const titleBoxTop = height * 0.086;
    const titleBoxBottom = height * 0.36;
    const totalHeight = lineHeights.reduce((sum, lineHeight) => sum + lineHeight, 0) + gap * 2;
    let y = titleBoxTop + (titleBoxBottom - titleBoxTop - totalHeight) / 2 + lineSizes[0] * 0.82 * shapes[0].scaleY;
    exportTitleLines.slice(0, 3).forEach((line, index) => {
      const lineSize = lineSizes[index];
      const baseWidth = index === 0 ? 0.9 : 0.82;
      drawFittedText(ctx, line, cx, y, width * Math.max(0.5, Math.min(0.94, baseWidth * lineScales[index])), lineSize, {
        family: shapes[index].exportFamily,
        weight: shapes[index].weight,
        minScale: 0.34,
        scaleY: shapes[index].scaleY
      });
      y += lineSize * shapes[index].scaleY + gap;
    });
  } else if (exportTitleLines.length === 2) {
    const size = 248 * titleScale;
    const firstShape = titleLineSettings(exportTitleLines[0], exportTitleLines.length);
    const secondShape = titleLineSettings(exportTitleLines[1], exportTitleLines.length);
    const firstSize = size * lineScales[0];
    const secondSize = size * lineScales[1];
    const firstLineHeight = firstSize * firstShape.scaleY;
    const secondLineHeight = secondSize * secondShape.scaleY;
    const gap = ((firstLineHeight + secondLineHeight) / 2) * twoLineTitleGap(exportTitleLines[0], exportTitleLines[1]);
    const titleBoxTop = height * 0.072;
    const titleBoxBottom = height * 0.392;
    const titleLift = longTwoLineTitle ? height * 0.035 : 0;
    const firstY = titleBoxTop + (titleBoxBottom - titleBoxTop - firstLineHeight - secondLineHeight - gap) / 2 + firstSize * 0.82 * firstShape.scaleY - titleLift;
    const secondY = firstY + firstLineHeight + gap;
    drawFittedText(ctx, exportTitleLines[0], cx, firstY, width * Math.max(0.58, Math.min(0.96, 0.9 * lineScales[0])), firstSize, {
      family: firstShape.exportFamily,
      weight: firstShape.weight,
      minScale: 0.36,
      scaleY: firstShape.scaleY
    });
    drawFittedText(ctx, exportTitleLines[1], cx, secondY, width * Math.max(0.58, Math.min(0.94, 0.84 * lineScales[1])), secondSize, {
      family: secondShape.exportFamily,
      weight: secondShape.weight,
      minScale: 0.32,
      scaleY: secondShape.scaleY
    });
  } else {
    const singleTitleShape = singleTitleSettings(data.headlineOne);
    const size = singleTitleShape.exportSize * titleScale * lineScales[0];
    const scaleY = singleTitleShape.scaleY;
    const titleBoxTop = height * 0.075;
    const titleBoxBottom = height * 0.35;
    const y = titleBoxTop + (titleBoxBottom - titleBoxTop - size * scaleY) / 2 + size * 0.82 * scaleY;
    drawFittedText(ctx, data.headlineOne, cx, y, width * Math.max(0.54, Math.min(0.94, singleTitleShape.exportWidth * lineScales[0])), size, {
      family: singleTitleShape.exportFamily,
      weight: singleTitleShape.weight,
      minScale: 0.38,
      scaleY,
      fillWidth: false
    });
  }

  drawFittedText(ctx, data.guestLabel, cx, height * ((hasThreeTitleLines ? 0.435 : 0.422) + lowerStackOffset + middleLift + contentLift), width * 0.68, 27 * supportScale, {
    style: "italic",
    minScale: 0.55
  });

  drawFittedText(ctx, data.supportAct, cx, height * ((hasThreeTitleLines ? 0.495 : 0.485) + lowerStackOffset + middleLift + contentLift), width * 0.8, 54 * supportScale, {
    minScale: 0.42
  });

  drawFittedText(ctx, data.dateLine, cx, height * (0.548 + lowerStackOffset + middleLift + contentLift), copyWidth, 36 * detailScale, {
    family: "Arial Black, Arial, sans-serif",
    minScale: 0.32
  });

  drawFittedText(ctx, data.agesLine, cx, height * (0.595 + lowerStackOffset + middleLift + contentLift), width * 0.62, 25 * detailScale, {
    family: "Arial Black, Arial, sans-serif",
    minScale: 0.42
  });

  drawFittedText(ctx, data.doorsLine, width * 0.25, height * (0.642 + lowerStackOffset + middleLift + contentLift), width * 0.43, 22 * detailScale, {
    family: "Arial Narrow, Impact, sans-serif",
    minScale: 0.32
  });
  drawFittedText(ctx, data.showLine, width * 0.75, height * (0.642 + lowerStackOffset + middleLift + contentLift), width * 0.43, 22 * detailScale, {
    family: "Arial Narrow, Impact, sans-serif",
    minScale: 0.32
  });

  drawFittedText(ctx, data.venueLine, cx, height * (0.704 + lowerStackOffset + middleLift + contentLift), copyWidth, 31 * detailScale, {
    family: "Arial Narrow, Impact, sans-serif",
    minScale: 0.36
  });

  drawFittedText(ctx, data.addressLine, cx, height * (0.746 + lowerStackOffset + middleLift + contentLift), copyWidth, 27 * detailScale, {
    family: "Arial Narrow, Impact, sans-serif",
    minScale: 0.34
  });

  drawFittedText(ctx, data.noteLine, cx, height * (0.765 + lowerStackOffset + middleLift + contentLift), width * 0.88, 40 * detailScale, {
    family: "Arial Narrow, Impact, sans-serif",
    minScale: 0.42
  });

  drawFittedText(ctx, data.tinyLineOne, cx, height * (0.798 + lowerStackOffset + middleLift + contentLift), width * 0.88, 36 * fineScale, {
    family: "Arial Narrow, Arial, sans-serif",
    minScale: 0.4
  });
  drawFittedText(ctx, data.tinyLineTwo, cx, height * (0.83 + lowerStackOffset + middleLift + contentLift), width * 0.86, 44 * fineScale, {
    family: "Arial Narrow, Impact, sans-serif",
    minScale: 0.46
  });
  drawFittedText(ctx, data.tinyLineThree, cx, height * (0.858 + lowerStackOffset + middleLift + contentLift), width * 0.82, 38 * fineScale, {
    family: "Arial Narrow, Arial, sans-serif",
    minScale: 0.48
  });
}

function exportHeadlineTwoWidth(text, posterWidth) {
  return (text || "").replace(/\s+/g, "").length > 5 ? posterWidth * 0.86 : posterWidth * 0.56;
}

function singleTitleSettings(text) {
  const length = (text || "").replace(/\s+/g, "").length;
  if (length <= 3) return { maxCqw: 46, exportSize: 460, scaleY: 1.26, maxScaleX: 1, target: 0.94, exportWidth: 0.94, family: '"Anton", Impact, "Arial Black", sans-serif', exportFamily: "Anton, Impact, Arial Black, sans-serif", weight: "400" };
  if (length <= 6) return { maxCqw: 36, exportSize: 360, scaleY: 1.2, maxScaleX: 1, target: 0.86, exportWidth: 0.86, family: '"Anton", Impact, "Arial Black", sans-serif', exportFamily: "Anton, Impact, Arial Black, sans-serif", weight: "400" };
  if (length <= 8) return { maxCqw: 32, exportSize: 320, scaleY: 1.12, maxScaleX: 1, target: 0.9, exportWidth: 0.9, family: '"Arial Black", Impact, sans-serif', exportFamily: "Arial Black, Impact, sans-serif", weight: "900" };
  return { maxCqw: 30, exportSize: 300, scaleY: 1.1, maxScaleX: 1, target: 0.88, exportWidth: 0.88, family: '"Arial Black", Impact, sans-serif', exportFamily: "Arial Black, Impact, sans-serif", weight: "900" };
}

function titleLineSettings(text, lineCount) {
  return titleFontCandidates(text, lineCount)[0];
}

controls.addEventListener("input", schedulePreview);
controls.addEventListener("submit", (event) => event.preventDefault());
document.querySelector("#download").addEventListener("click", async () => {
  const button = document.querySelector("#download");
  const status = document.querySelector("#saveStatus");
  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = "Saving...";
  if (status) status.textContent = "";
  try {
    await exportPoster();
    button.textContent = "Saved";
    if (status) status.textContent = "PNG download started.";
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
      if (status) status.textContent = "";
    }, 900);
  } catch (error) {
    console.error(error);
    button.textContent = "Save failed";
    if (status) status.textContent = error?.message || "Save failed.";
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 1400);
  }
});
document.querySelectorAll(".line-size").forEach((button) => {
  button.addEventListener("click", () => {
    const key = button.dataset.lineScale;
    if (button.dataset.reset) {
      setLineScale(key, 100);
      return;
    }
    setLineScale(key, (Number(controls.elements[key].value) || 100) + Number(button.dataset.step || 0));
  });
});
document.querySelector("#randomShow").addEventListener("click", () => {
  const choices = ranchBowlShows.filter((show) => headlinerKey(show) !== lastRandomHeadliner);
  const show = choices[Math.floor(Math.random() * choices.length)] || ranchBowlShows[0];
  lastRandomHeadliner = headlinerKey(show);
  const currentColor = controls.querySelector('input[name="paperColor"]:checked')?.value;
  applyValues({ ...show, paperColor: currentColor || 'yellow' });
});
document.querySelector("#reset").addEventListener("click", () => { foldsEnabled=true; setMount("tape"); applyValues(defaults); document.querySelector("#folds").checked=true;  });
document.querySelector("#folds").addEventListener("click", () => {
  foldsEnabled = document.querySelector("#folds").checked;
  const button = document.querySelector("#folds");


  updatePreview();
});
document.querySelector("#tapeCorners").addEventListener("click", () => {
  if(document.body.dataset.wall==='crowd'){crowdHandsEnabled=!crowdHandsEnabled;document.body.dataset.hands=crowdHandsEnabled?'on':'off';setMount('held');return;}
  const choices = availableMounts();
  setMount(choices[(choices.indexOf(mounting)+1)%choices.length]);
  updatePreview();
});
// Mobile browser chrome/keyboard resizes must not re-fit an unchanged flyer.
let lastPosterSize = '';
new ResizeObserver(([entry]) => {
  const size = `${entry.contentRect.width}:${entry.contentRect.height}`;
  if (size === lastPosterSize) return;
  lastPosterSize = size;
  schedulePreview();
}).observe(document.querySelector("#poster"));
bg.addEventListener("load", updatePreview);
updatePreview();

function setLineScale(key, value) {
  const field = controls.elements[key];
  if (!field) return;
  field.value = String(Math.max(70, Math.min(135, value)));
  updatePreview();
}

function headlinerKey(show) {
  return `${show.headlineOne} ${show.headlineTwo} ${show.headlineThree}`.trim().replace(/\s+/g, " ").toUpperCase();
}

function drawFoldLines(ctx, width, height) {
  ctx.save();
  ctx.globalCompositeOperation = "multiply";
  const vertical = width * 0.5;
  const horizontal = height * 0.5;
  const vGradient = ctx.createLinearGradient(vertical - 12, 0, vertical + 12, 0);
  vGradient.addColorStop(0, "rgba(0,0,0,0)");
  vGradient.addColorStop(0.34, "rgba(24,22,0,0.16)");
  vGradient.addColorStop(0.45, "rgba(8,8,0,0.26)");
  vGradient.addColorStop(0.53, "rgba(255,255,185,0.24)");
  vGradient.addColorStop(0.63, "rgba(42,38,0,0.16)");
  vGradient.addColorStop(1, "rgba(0,0,0,0)");
  ctx.fillStyle = vGradient;
  ctx.fillRect(vertical - 12, 0, 24, height);

  const hGradient = ctx.createLinearGradient(0, horizontal - 12, 0, horizontal + 12);
  hGradient.addColorStop(0, "rgba(0,0,0,0)");
  hGradient.addColorStop(0.34, "rgba(24,22,0,0.15)");
  hGradient.addColorStop(0.45, "rgba(8,8,0,0.24)");
  hGradient.addColorStop(0.53, "rgba(255,255,185,0.22)");
  hGradient.addColorStop(0.63, "rgba(42,38,0,0.15)");
  hGradient.addColorStop(1, "rgba(0,0,0,0)");
  ctx.fillStyle = hGradient;
  ctx.fillRect(0, horizontal - 12, width, 24);
  ctx.restore();
}

function drawTapeCorners(ctx, width, height, offsetX = 0, offsetY = 0) {
  const tapes = [
    { x: width * 0.02, y: height * 0.008, rotate: -34 },
    { x: width * 0.98, y: height * 0.008, rotate: 34 },
    { x: width * 0.02, y: height * 0.992, rotate: 34 },
    { x: width * 0.98, y: height * 0.992, rotate: -34 }
  ];
  const tapeWidth = width * 0.22;
  const tapeHeight = height * 0.032;

  tapes.forEach((tape) => {
    ctx.save();
    ctx.translate(offsetX + tape.x, offsetY + tape.y);
    ctx.rotate(tape.rotate * Math.PI / 180);
    const clearWindowTape = document.body.dataset.wall === 'wood';
    ctx.globalAlpha = 1;
    ctx.fillStyle = clearWindowTape ? "rgba(225,235,236,0.32)" : "#d4c294";
    ctx.shadowColor = "rgba(0,0,0,0.22)";
    ctx.shadowBlur = 5;
    ctx.shadowOffsetY = 2;
    ctx.fillRect(-tapeWidth / 2, -tapeHeight / 2, tapeWidth, tapeHeight);
    ctx.shadowColor = "transparent";
    ctx.globalCompositeOperation = "multiply";
    ctx.fillStyle = "rgba(120, 102, 42, 0.12)";
    for (let i = -tapeWidth / 2; i < tapeWidth / 2; i += 9) {
      ctx.fillRect(i, -tapeHeight / 2, 1.2, tapeHeight);
    }
    ctx.restore();
  });
}

function renderData() {
  const data = posterData();
  const names = ['headlineOne','headlineTwo','headlineThree'];
  const scales = ['lineOneScale','lineTwoScale','lineThreeScale'];
  const active = names.map((name,index) => ({text:data[name],scale:data[scales[index]]})).filter(line => line.text.trim());
  names.forEach((name,index) => { data[name] = active[index]?.text || ''; data[scales[index]] = active[index]?.scale || '100'; });
  return data;
}
function schedulePreview() {
  cancelAnimationFrame(schedulePreview.frame);
  schedulePreview.frame = requestAnimationFrame(updatePreview);
}


// Reserve the background's logo band. Measure actual text, including transformed spans.
function fitCopyAboveLogos(poster) {
  const layer = poster.querySelector('.poster-copy');
  const bounds = poster.getBoundingClientRect();
  const nodes = [...layer.querySelectorAll('.ink')].filter(node => node.textContent.trim() && getComputedStyle(node).display !== 'none');
  for (const node of nodes) {
    const range = document.createRange();
    range.selectNodeContents(node.querySelector('.fine-text') || node);
    const text = range.getBoundingClientRect();
    const column = node.classList.contains('left') ? 0.25 : node.classList.contains('right') ? 0.75 : 0.5;
    const left = parseFloat(getComputedStyle(node).left) || 0;
    node.style.left = (left + bounds.left + bounds.width * column - (text.left + text.width / 2)) + 'px';
  }
  const rects = nodes.map(node => {
    const range = document.createRange();
    range.selectNodeContents(node.querySelector('.fine-text') || node);
    return range.getBoundingClientRect();
  });
  if (!rects.length) return;
  const top = Math.min(...rects.map(rect => rect.top - bounds.top));
  const bottom = Math.max(...rects.map(rect => rect.bottom - bounds.top));
  const safeBottom = bounds.height * 0.835;
  if (bottom > safeBottom) {
    const scale = Math.max(0.01, (safeBottom - Math.max(0,top)) / (bottom - top));
    layer.style.transform = 'translateY(' + (Math.max(0,top) - top * scale) + 'px) scaleY(' + scale + ')';
  }
}





;
const wallChoices = [
  { id: 'none', label: 'No background', file: null },
  { id: 'brick', label: 'Brick wall', file: rfAsset('assets/walls/brick.jpg') },
  { id: 'dive-bar', label: 'Dive bar', file: rfAsset('assets/walls/dive-bar.jpg') },
  { id: 'poster-fence', label: 'Posters', file: rfAsset('assets/walls/poster-fence.jpg') },
  { id: 'wood', label: "Record store window", file: rfAsset('assets/walls/wood.jpg') },
  { id: 'crowd', label: 'Ranch Bowl crowd', file: rfAsset('assets/walls/crowd.jpg') },
  { id: 'light-pole', label: 'Light pole', file: rfAsset('assets/walls/light-pole.jpg') },
  { id: 'fridge', label: 'Fridge', file: rfAsset('assets/walls/kitchen.jpg') },
  { id: 'frame', label: 'Framed', file: rfAsset('assets/walls/modern-wall.jpg') }
];
const wallButton = document.querySelector('#wall');
let wallRequest = 0;
const poleScene = document.createElement('div');
poleScene.className = 'pole-scene';
poleScene.setAttribute('aria-hidden', 'true');
poleScene.innerHTML = '<span class="pole-street-left"></span><span class="pole-original"></span><span class="pole-street-right"></span>';
document.body.prepend(poleScene);
function alignLightPole() {
  const bounds = document.querySelector('.poster-wrap').getBoundingClientRect();
  const posterCenter = bounds.left + bounds.width / 2;
  const photoWidth = Math.max(bounds.width * 1.18 / .224, window.innerWidth, window.innerHeight * 1.5, posterCenter / .25, (window.innerWidth - posterCenter) / .75);
  document.body.style.setProperty('--pole-photo-width', `${photoWidth}px`);
  document.body.style.setProperty('--pole-photo-left', `${posterCenter - photoWidth * .25}px`);
}
new ResizeObserver(alignLightPole).observe(document.querySelector('.stage'));
// Ordinary eight-inch bricks should keep their scale against an 11-inch flyer.
function alignBrickWall() {
  const bounds = document.querySelector('.poster-wrap').getBoundingClientRect();
  const photoWidth = Math.max(bounds.width * 6.1, window.innerWidth, window.innerHeight * 1672 / 940);
  document.body.style.setProperty('--brick-photo-width', `${photoWidth}px`);
  document.body.style.setProperty('--brick-photo-left', `${bounds.left + bounds.width / 2 - photoWidth * .26}px`);
}
new ResizeObserver(alignBrickWall).observe(document.querySelector('.poster-wrap'));
// Fridge wall: a cream enamel fridge door behind the poster, with magnets holding it on.
const fridgeScene = document.createElement('div');
fridgeScene.className = 'fridge-scene';
fridgeScene.setAttribute('aria-hidden', 'true');
fridgeScene.innerHTML = '<span class="fridge-door"></span><span class="fridge-handle"></span>';
document.body.prepend(fridgeScene);
function alignFridge() {
  const bounds = document.querySelector('.poster-wrap').getBoundingClientRect();
  document.body.style.setProperty('--fridge-width', `${bounds.width * 1.95}px`);
  document.body.style.setProperty('--fridge-left', `${bounds.left - bounds.width * .57}px`);
  document.body.style.setProperty('--fridge-top', `${bounds.top - bounds.height * .24}px`);
}
new ResizeObserver(alignFridge).observe(document.querySelector('.stage'));
window.addEventListener('resize', alignFridge);
// Framed wall: black frame + white mat around the poster, glass on top (shown only on the Framed wall).
const frameArt = document.createElement('div');
frameArt.className = 'frame-art';
frameArt.setAttribute('aria-hidden', 'true');
const frameGlass = document.createElement('div');
frameGlass.className = 'frame-glass';
frameGlass.setAttribute('aria-hidden', 'true');
document.querySelector('.poster-wrap').prepend(frameArt);
document.querySelector('.poster-wrap').append(frameGlass);
// Ticket stubs tucked under the frame's bottom-right edge (clipped by the frame opening).
const frameTuck = document.createElement('div');
frameTuck.className = 'frame-tuck';
frameTuck.setAttribute('aria-hidden', 'true');
frameTuck.innerHTML = `<img src="${rfAsset('assets/mounts/tickets.png')}" alt="">`;
document.querySelector('.poster-wrap').append(frameTuck);
// A light switch beside the frame so it reads as a wall.
// Clicking it turns the room lights off: everything goes dark except the lamp-lit poster.
const wallSwitch = document.createElement('button');
wallSwitch.type = 'button';
wallSwitch.className = 'wall-switch';
wallSwitch.setAttribute('aria-pressed', 'true');
wallSwitch.setAttribute('aria-label', 'Room lights');
wallSwitch.title = 'Turn the lights off';
wallSwitch.innerHTML = '<span class="wall-switch-rocker"></span>';
document.querySelector('.poster-wrap').append(wallSwitch);
const pictureLight = document.createElement('div');
pictureLight.className = 'picture-light';
pictureLight.setAttribute('aria-hidden', 'true');
pictureLight.innerHTML = '<span class="picture-light-plate"></span><span class="picture-light-arm"></span><span class="picture-light-bar"></span>';
document.querySelector('.poster-wrap').append(pictureLight);
const roomDark = document.createElement('div');
roomDark.className = 'room-dark';
roomDark.setAttribute('aria-hidden', 'true');
document.body.append(roomDark);
function aimSpotlight() {
  const frame = document.querySelector('.frame-art').getBoundingClientRect();
  if (!frame.width) return;
  document.body.style.setProperty('--spot-x', `${frame.left + frame.width / 2}px`);
  document.body.style.setProperty('--spot-y', `${frame.top + frame.height * 0.42}px`);
  document.body.style.setProperty('--spot-rx', `${frame.width * 0.78}px`);
  document.body.style.setProperty('--spot-ry', `${frame.height * 0.74}px`);
}
// Put the switch where it's visible: right of the frame, else left of it, else below the control panel.
function placeSwitch() {
  if (document.body.dataset.wall !== 'frame') return;
  wallSwitch.style.left = ''; wallSwitch.style.top = '';
  const wrap = document.querySelector('.poster-wrap').getBoundingClientRect();
  const frame = document.querySelector('.frame-art').getBoundingClientRect();
  const panel = document.querySelector('.panel').getBoundingClientRect();
  const sw = wallSwitch.getBoundingClientRect();
  if (!frame.width || !sw.width) return;
  const gap = Math.max(14, wrap.width * .05), viewW = document.documentElement.clientWidth;
  const safeLeft = 12, safeRight = viewW - 12;
  const hits = (x, y) => x < panel.right && x + sw.width > panel.left && y < panel.bottom && y + sw.height > panel.top;
  const fits = (x, y) => x >= safeLeft && x + sw.width <= safeRight && !hits(x, y);
  const y = Math.max(12, frame.top + frame.height * .48), viewH = document.documentElement.clientHeight;
  // Phones: no wall to spare, so the switch floats on the frame's right edge, fully on screen.
  if (matchMedia('(max-width: 840px)').matches) {
    const x = Math.min(frame.right - sw.width * .72, viewW - sw.width - 6);
    wallSwitch.style.left = `${x - wrap.left}px`;
    wallSwitch.style.top = `${y - wrap.top}px`;
    return;
  }
  const inView = (top) => top + sw.height <= viewH - 6;
  const candidates = [
    [frame.right + gap, y, fits],
    [frame.left - gap - sw.width, y, fits],
    [frame.right + gap, Math.max(y, panel.bottom + 12), fits],
    // small screens: let it peek in from the right edge, clear of the frame and panel
    [Math.max(safeLeft, safeRight - sw.width), Math.max(12, panel.top - sw.height - 12), fits]
  ];
  const spot = candidates.find(([x, top, ok]) => ok(x, top) && inView(top));
  if (!spot) {
    // Keep the entire control inside the clipping container even when space is tight.
    wallSwitch.style.left = `${Math.max(safeLeft, Math.min(frame.left - gap - sw.width, safeRight - sw.width)) - wrap.left}px`;
    wallSwitch.style.top = `${Math.max(12, Math.min(y, viewH - sw.height - 12)) - wrap.top}px`;
    return;
  }
  wallSwitch.style.left = `${spot[0] - wrap.left}px`;
  wallSwitch.style.top = `${spot[1] - wrap.top}px`;
}
new ResizeObserver(() => requestAnimationFrame(placeSwitch)).observe(document.querySelector('.stage'));
window.addEventListener('resize', () => requestAnimationFrame(placeSwitch));
function setRoomLights(on) {
  document.body.classList.toggle('lights-off', !on);
  wallSwitch.setAttribute('aria-pressed', String(on));
  wallSwitch.title = on ? 'Turn the lights off' : 'Turn the lights on';
  if (!on) aimSpotlight();
}
wallSwitch.addEventListener('click', () => setRoomLights(document.body.classList.contains('lights-off')));
// Phones: the switch is hidden; tapping the framed poster flips the lights instead.
document.querySelector('.poster-wrap').addEventListener('click', (event) => {
  if (document.body.dataset.wall !== 'frame' || !matchMedia('(max-width: 840px)').matches || event.target.closest('.wall-switch')) return;
  setRoomLights(document.body.classList.contains('lights-off'));
});
new ResizeObserver(aimSpotlight).observe(document.querySelector('.stage'));
window.addEventListener('resize', aimSpotlight);
window.addEventListener('scroll', aimSpotlight, { passive: true });
// Scenes with a fixed, integrated holding method.
const wallMounts = { crowd:'held', fridge: 'magnets', frame: 'tickets' };
window.addEventListener('resize', alignLightPole);
function setWall(id) {
  ++wallRequest;
  wallButton.disabled = false;
  const choice = wallChoices.find(item => item.id === id) || wallChoices[0];
  document.body.dataset.wall = choice.id;
  document.querySelector('#tapeCorners').disabled=false;
  if (choice.id === 'light-pole') alignLightPole();
  if (choice.id === 'fridge') alignFridge();
  if (choice.id === 'brick') alignBrickWall();
  // The Framed wall opens with the room lights off (lamp on); every other wall has the lights on.
  if (choice.id !== 'frame') setRoomLights(true); else requestAnimationFrame(() => { placeSwitch(); setRoomLights(false); });
  // Pick a mount that belongs on this surface, preserving it only when it's allowed.
  const wallMount = wallMounts[choice.id];
  const allowedMounts = availableMounts();
  const nextMount = wallMount || (allowedMounts.includes(mounting) ? mounting : (allowedMounts[0] || 'none'));
  setMount(nextMount);
  updatePreview();

  document.body.style.setProperty('--wall-photo', choice.file ? `url("${choice.file}")` : 'none');
  wallButton.textContent = 'Scene';
  wallButton.title = `Scene: ${choice.label}. Click for the next scene.`;
  wallButton.setAttribute('aria-label', `Scene: ${choice.label}. Next scene`);
}
// The legacy scene button cycles backgrounds; the picker below controls shuffle locking.
wallButton.addEventListener('click', async () => {
  const request = ++wallRequest;
  const current = wallChoices.findIndex(item => item.id === document.body.dataset.wall);
  const next = wallChoices[(Math.max(current,0) + 1) % wallChoices.length];
  wallButton.disabled = true;
  try {
    if (next.file) {
      const photo = rfImage();
      photo.src=rfAsset(next.file);
      await photo.decode();
    }
    if (request !== wallRequest) return;
    setWall(next.id);
    document.querySelector('#wallStatus').textContent = `Background: ${next.label}`;
    wallButton.dispatchEvent(new CustomEvent('wallchange', { bubbles:true }));
  } catch {
    document.querySelector('#wallStatus').textContent = 'Scene photo could not load. Please try again.';
  } finally { if (request === wallRequest) wallButton.disabled = false; }
});
document.querySelector('#reset').addEventListener('click', () => {
  ++wallRequest;
  wallButton.disabled = false;
  setWall('wood');
});
setWall('wood');




;
(() => {
  const storageKey = 'ranchbowl-studio-v1';
  const undo = document.querySelector('#undo');
  const redo = document.querySelector('#redo');
  const status = document.querySelector('#draftStatus');
  const snapshot = () => JSON.stringify({version:1,values:posterData(),folds:foldsEnabled,tape:tapeEnabled,mount:mounting,wall:document.body.dataset.wall || "none",hands:crowdHandsEnabled,lights:!document.body.classList.contains("lights-off")});
  let history = [], position = -1, timer;
  function buttons() { undo.disabled = position <= 0; redo.disabled = position >= history.length-1; }
  function persist() {
    try { localStorage.setItem(storageKey,snapshot()); status.textContent = 'Draft saved on this device.'; }
    catch { status.textContent = 'Draft storage unavailable. Keep this page open or save a PNG.'; }
  }
  function remember() {
    clearTimeout(timer);
    const state = snapshot();
    if(history[position] !== state) {
      history = history.slice(0,position+1); history.push(state);
      if(history.length > 60) history.shift();
      position = history.length-1;
    }
    buttons(); persist();
  }
  function restore(state) {
    const parsed = JSON.parse(state);
    if(parsed.version !== 1 || !parsed.values || typeof parsed.values !== 'object') return false;
    const clean = {};
    for(const key of Object.keys(defaults)) if(typeof parsed.values[key] === 'string') clean[key] = parsed.values[key].slice(0,1000);
    foldsEnabled = parsed.folds !== false;
    crowdHandsEnabled=parsed.hands!==false;document.body.dataset.hands=crowdHandsEnabled?'on':'off';
    setWall(wallChoices.some(choice=>choice.id===parsed.wall)?parsed.wall:'wood');
    setMount(parsed.mount || (parsed.tape === true ? 'tape' : 'none'));
    applyValues({...defaults,...clean});
    document.querySelector('#folds').checked=foldsEnabled;
    if(typeof parsed.lights==='boolean')requestAnimationFrame(()=>{setRoomLights(parsed.lights);persist();});
    return true;
  }
  try { const saved=localStorage.getItem(storageKey); if(saved) restore(saved); } catch { /* Start fresh if the saved draft is invalid or unavailable. */ }
  // Refresh the background each load; shared links restore their exact appearance below.
  if(!new URL(location.href).searchParams.has('creation')){
    const backgrounds=wallChoices.filter(choice=>choice.id!=='none' && choice.id!==document.body.dataset.wall);
    const initial=backgrounds[Math.floor(Math.random()*backgrounds.length)];
    if(initial)setWall(initial.id);
  }
  remember();
  controls.addEventListener('input',() => { persist(); clearTimeout(timer); timer=setTimeout(remember,450); });
  controls.addEventListener('change',remember);
  document.querySelector(".panel").addEventListener("wallchange",()=>{remember();requestAnimationFrame(persist);});
  document.querySelector('.panel').addEventListener('click',event => {
    if(event.target.closest('.line-size, #randomShow, #reset, #folds, #tapeCorners')) remember();
  });
  undo.addEventListener('click',() => { remember(); if(position>0) {restore(history[--position]); buttons(); persist();} });
  redo.addEventListener('click',() => {if(position<history.length-1) {restore(history[++position]); buttons(); persist();} });
  const picker=document.querySelector('#showPicker');
  const sorter=document.querySelector('#showSort');
  const months={JAN:1,FEB:2,MAR:3,APR:4,MAY:5,JUN:6,JUL:7,AUG:8,SEP:9,OCT:10,NOV:11,DEC:12};
  const ordinals=['FIRST','SECOND','THIRD','FOURTH','FIFTH','SIXTH','SEVENTH','EIGHTH','NINTH','TENTH','ELEVENTH','TWELFTH','THIRTEENTH','FOURTEENTH','FIFTEENTH','SIXTEENTH','SEVENTEENTH','EIGHTEENTH','NINETEENTH','TWENTIETH'];
  // Sortable number from a free-text date line; shows with no year sort after dated ones.
  function dateKey(text) {
    const t=String(text||'').toUpperCase();
    const year=(t.match(/\b(19|20)\d{2}\b/)||[])[0];
    let month=0, day=0;
    const slash=t.match(/\b(\d{1,2})\/(\d{1,2})\b/);
    const named=t.match(/\b(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)[A-Z]*\.?\s+(\d{1,2})?/);
    if(named) {
      month=months[named[1]];
      day=Number(named[2]||0);
      if(!day) { const word=t.slice(named.index).match(/\b([A-Z]+)\b/g)?.find(w => ordinals.includes(w)); if(word) day=ordinals.indexOf(word)+1; }
    } else if(slash) { month=Number(slash[1]); day=Number(slash[2]); }
    return (year?Number(year):9999)*10000+month*100+day;
  }
  const bandKey=show => headlinerKey(show).replace(/^THE\s+/,'');
  function shows() {
    const chosen=picker.value;
    const order=ranchBowlShows.map((show,index) => ({show,index}));
    if(sorter && sorter.value==='date') order.sort((a,b) => dateKey(a.show.dateLine)-dateKey(b.show.dateLine) || bandKey(a.show).localeCompare(bandKey(b.show),undefined,{numeric:true}));
    else order.sort((a,b) => bandKey(a.show).localeCompare(bandKey(b.show),undefined,{numeric:true}) || dateKey(a.show.dateLine)-dateKey(b.show.dateLine));
    picker.replaceChildren(new Option('Choose a past show…',''));
    order.forEach(({show,index}) => {
      const band=headlinerKey(show);
      const shortBand=band.length>42 ? band.slice(0,39).trimEnd()+'…' : band;
      const key=dateKey(show.dateLine);
      const year=Math.floor(key/10000), month=Math.floor(key/100)%100, day=key%100;
      const date=year<9999 && month && day ? `${month}/${day}/${year}` : String(show.dateLine||'').replace(/^(MONDAY|TUESDAY|WEDNESDAY|THURSDAY|FRIDAY|SATURDAY|SUNDAY)\s+/i,'').slice(0,24);
      const option=new Option(shortBand+' — '+date,String(index));
      option.title=band+' — '+show.dateLine;
      picker.add(option);
    });
    picker.value=chosen;
  }
  if(sorter) {
    try { const saved=localStorage.getItem('ranchbowl-show-sort'); if(saved==='date'||saved==='band') sorter.value=saved; } catch { /* keep default */ }
    sorter.addEventListener('change',() => { shows(); try { localStorage.setItem('ranchbowl-show-sort',sorter.value); } catch { /* not saved */ } });
  }
  shows();

  picker.addEventListener('change',() => {
    if(picker.value==='') return;
    remember();
    // Choosing a show updates content while preserving appearance.
    const currentColor=controls.querySelector('input[name="paperColor"]:checked')?.value;
    const show=ranchBowlShows[Number(picker.value)];
    applyValues({...show,paperColor:currentColor||'yellow'});
    remember();
  });

})();


// Desktop sections keep every field accessible without a tall scrolling panel.
(() => {
  const desktop = matchMedia('(min-width: 841px)');
  const form = document.querySelector('#controls');
  const details = form.querySelector('.details-panel');
  const mainButton = document.querySelector('#mainSection');
  const detailsButton = document.querySelector('#detailsSection');
  function show(section) {
    form.dataset.section = section;
    mainButton.setAttribute('aria-pressed', String(section === 'main'));
    detailsButton.setAttribute('aria-pressed', String(section === 'details'));
  }
  mainButton.addEventListener('click', () => show('main'));
  detailsButton.addEventListener('click', () => show('details'));
  function adapt() { details.open = true; show('main'); }
  desktop.addEventListener('change', adapt);
  adapt();
})();





// Native dropdowns for direct mounting and scene selection.
(() => {
  const oldMount = document.querySelector('#tapeCorners');
  const oldScene = document.querySelector('#wall');
  const mountSelect = document.createElement('select');
  const sceneSelect = document.createElement('select');
  mountSelect.id = 'mountPicker'; mountSelect.setAttribute('aria-label','Mount');
  sceneSelect.id = 'scenePicker'; sceneSelect.setAttribute('aria-label','Scene');
  const names = {tape:'Tape',staples:'Staples',thumbtacks:'Thumbtacks',magnets:'Magnets',tickets:'Tickets',none:'None',held:'Held'};
  const shortScenes = {none:'No background',brick:'Brick','dive-bar':'Dive bar','poster-fence':'Posters',wood:'Window',crowd:'Crowd','light-pole':'Pole',fridge:'Fridge',frame:'Framed'};
  for (const choice of wallChoices) {
    const option=document.createElement('option'); option.value=choice.id; option.textContent=shortScenes[choice.id];sceneSelect.append(option);
  }
  oldMount.before(mountSelect); oldScene.before(sceneSelect);
  oldMount.style.setProperty('display','none','important');oldScene.style.setProperty('display','none','important');
  // Keep the original reset hook in the DOM for compatibility, but remove it from the UI.
  const resetButton=document.querySelector('#reset');
  if(resetButton) resetButton.style.setProperty('display','none','important');
  const style=document.createElement('style');
  style.textContent='@media(min-width:841px){.app .panel{width:100%;max-width:680px;justify-self:start}}.app .panel{min-width:0}.app .panel .actions>button,.app .panel .actions>select{font-size:10px!important;font-weight:600!important;letter-spacing:0}.panel .actions{width:100%;min-width:0;grid-template-columns:repeat(4,minmax(0,1fr))!important}.panel .actions>*{min-width:0;max-width:100%}.panel .actions #mountPicker,.panel .actions #scenePicker{box-sizing:border-box;width:100%;min-width:0;contain:inline-size;min-height:34px;padding:5px 3px;background:#171b1d;color:#f3df9a;border:1px solid #6b5930;border-radius:3px;font:700 11px/1.2 Arial,sans-serif;cursor:pointer}.panel .actions #mountPicker:focus-visible,.panel .actions #scenePicker:focus-visible{outline:2px solid #d9bb56;outline-offset:2px}@media(max-width:840px){.app .panel .actions>button,.app .panel .actions>select{font-size:9px!important}.panel .actions #mountPicker,.panel .actions #scenePicker{min-height:38px}}@media(max-width:840px){.panel .actions{grid-template-columns:repeat(2,minmax(0,1fr)) 1.35fr!important}}';
  document.head.append(style);
  function refresh() {
    const choices=mounting==='held'?['hands-on','hands-off']:availableMounts();
    const signature=choices.join(',');
    if(mountSelect.dataset.choices!==signature){mountSelect.replaceChildren();for(const id of choices){const option=document.createElement('option');option.value=id;option.textContent=id==='hands-on'?'Hands on':id==='hands-off'?'Hands off':names[id];mountSelect.append(option)}mountSelect.dataset.choices=signature}
    mountSelect.value=mounting==='held'?(crowdHandsEnabled?'hands-on':'hands-off'):mounting;
    sceneSelect.value=document.body.dataset.wall;
  }
  function save(){oldMount.dispatchEvent(new CustomEvent('wallchange',{bubbles:true}));refresh()}
  mountSelect.addEventListener('change',()=>{
    if(mountSelect.value.startsWith('hands-')){crowdHandsEnabled=mountSelect.value==='hands-on';document.body.dataset.hands=crowdHandsEnabled?'on':'off';setMount('held')}
    else setMount(mountSelect.value);
    updatePreview();save();
  });
  sceneSelect.addEventListener('change',()=>{setWall(sceneSelect.value);document.querySelector('#wallStatus').textContent='Background: '+wallChoices.find(c=>c.id===sceneSelect.value).label;save()});
  const randomScene=document.createElement('button');
  randomScene.type='button';randomScene.id='randomScene';randomScene.textContent='Random scene';
  randomScene.title='Choose a different background without changing your flyer text';
  sceneSelect.after(randomScene);
  randomScene.addEventListener('click',()=>{
    const choices=wallChoices.filter(choice=>choice.id!==document.body.dataset.wall);
    const choice=choices[Math.floor(Math.random()*choices.length)];
    if(!choice)return;
    setWall(choice.id);
    document.querySelector('#wallStatus').textContent='Background: '+choice.label;
    save();
  });
  new MutationObserver(refresh).observe(document.body,{attributes:true,attributeFilter:['data-wall','data-hands']});
  new MutationObserver(refresh).observe(document.querySelector('.poster-wrap'),{attributes:true,attributeFilter:['data-mount']});
  refresh();
})();


window.ranchMakerShare({kind:'flyer',anchor:document.querySelector('.panel-head'),
 read:()=>({values:posterData(),folds:foldsEnabled,mount:mounting,wall:document.body.dataset.wall,hands:crowdHandsEnabled,lights:!document.body.classList.contains('lights-off')}),
 restore:s=>{
  if(!s.values || typeof s.values!=='object')throw Error('Missing text');
  const clean={...defaults};
  for(const key of Object.keys(defaults)){
   const value=s.values[key];if(typeof value!=='string')continue;
   if(key==='paperColor'){if([...controls.querySelectorAll('[name="paperColor"]')].some(el=>el.value===value))clean[key]=value;}
   else if(key.endsWith('Scale')){const n=Number(value);if(Number.isFinite(n))clean[key]=String(Math.max(25,Math.min(200,n)));}
   else clean[key]=value.slice(0,1000);
  }
  crowdHandsEnabled=s.hands!==false;document.body.dataset.hands=crowdHandsEnabled?'on':'off';
  setWall(wallChoices.some(c=>c.id===s.wall)?s.wall:'wood');
  setMount(typeof s.mount==='string'?s.mount:'tape');
  foldsEnabled=s.folds!==false;document.querySelector('#folds').checked=foldsEnabled;
  applyValues(clean);updatePreview();
  const shuffle=document.querySelector('#shuffleScenes');if(shuffle){shuffle.checked=false;shuffle.dispatchEvent(new Event('change'));}
  requestAnimationFrame(()=>{setRoomLights(s.lights!==false);document.querySelector('.panel').dispatchEvent(new CustomEvent('wallchange',{bubbles:true}));});
 }
});
})();
